<template>
    <div class="report">
        <div style="position:fixed;left:50%;width: 0px;height: 0px;">
            <div style="position:relative;">
                <el-button style="position: absolute;left: 110mm;top: 1px;background-color: #5B85FF;color: #fff;border-radius: 8px;padding: 10px;z-index: 999;" @click="savePdf">
                    保存为PDF
                </el-button>
            </div>
        </div>
        <div id="exportPdf_" ref="exportPdf_" :style="{backgroundColor: 'white !important',marginLeft:(WS-793)/2+'px',width: '793px',position: 'relative',zIndex: 10}">
            <div class="A4-2">
                <div style="width: 100%;height: 148.5mm;position: relative;">
                    <img src="../../../assets/images/report/eval-cover.png" style="width: 100%;height: 100%;" />
                    <img src="../../../assets/images/report/logo-word-cover.png"
                        style="position: absolute;width: 143px;top: 637px;right: 325px;" />
                </div>
                <div style="width: 100%;height: 155px;"></div>
                <h2
                    style="font-size: 38pt;text-align: center;font-weight: 600;color:#2973E2 !important;font-family: Microsoft JhengHei;">
                    <span class="font_padding">期</span><span class="font_padding">货</span><span
                        class="font_padding">交</span><span class="font_padding">易</span><span
                        class="font_padding">评</span><span class="font_padding">估</span><span
                        class="font_padding">报</span><span class="font_padding">告</span>
                </h2>
                <div style="width: 100%;height: 10px;"></div>
                <div
                    style="font-size: 18px;text-align: center;margin-top:20px;font-weight: 600;color:#2973E2 !important;">
                    <span class="font_padding1">报</span><span class="font_padding1">告</span><span
                        class="font_padding1">总</span><span class="font_padding1">交</span><span
                        class="font_padding1">易</span><span class="font_padding1">日</span><span
                        class="font_padding1">期</span>：{{eval.workDayCount}}天
                </div>
                <div
                    style="font-size: 12px;-webkit-transform: scale(0.8);text-align: center;color:#171718 !important;margin-top: 6px;margin-bottom: 40px">
                    （{{ res.reportStart  }}一{{ res.reportEnd  }}）
                </div>
                <div style="float: left;margin-left: 350px;">
                    <p class="title-info" style="text-align: left;font-family: Microsoft JhengHei;">
                        账号：{{ usr.clientId }}<br/>类型：{{res.face==1?'资金账号':usr.isSimulate?'模拟':'投顾'}}
                    </p>
                </div>
                
                <!-- <div style="width: 50%;float: left">
                    <p class="title-info" style="text-align: right;font-family: Microsoft JhengHei;">
                        
                    </p>
                </div> -->
                
                            <!-- <div style="width: 50%;float: left;font-family: Microsoft JhengHei;">
                    <p class="title-info">{{ user.name }}</p>
                    </div> -->

                <br />
                <br />
                <br />

                <br />
                <br />
                <div style="text-align: center;display: inline-block; width: 32.3%;float: left;margin-top: 50px;color:#7C7E80 !important"
                    class="font_size_setting">
                    网址：www.jeesit.com
                </div>
                <div style="text-align: center;width: 33.3%;display: inline-block;margin-top: 50px;color:#171718 !important;text-align: center;"
                    class="font_size_setting">
                    版权所有：武汉杰宜斯信息科技有限公司
                </div>
                <div style="text-align: center;width: 33.3%;display: inline-block;float: right;margin-top: 50px;color:#7C7E80 !important"
                    class="font_size_setting">
                    导出日期：{{ res.reportDate }}
                </div>
            </div>
            <div class="A4">
                <h2
                    style="color:#2973E2 !important;text-align: center;font-weight: 600;font-family: 'microsoft JhengHei'">
                    &nbsp;目录</h2>

                <div>
                    <h4>&nbsp;&nbsp;第<span class="catalognum">2</span>部分
                        数据分析....................................................................................................................................................<span
                            class="mulu" data="2"></span></h4>
                    <h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="catalognum_title">5</span>.<span
                            class="gmu2"></span>
                        &nbsp;&nbsp;净值与持仓.................................................................................................................................................<span
                            class="mulu" data="2"></span></h4>


                    <h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="catalognum_title">5</span>.<span
                            class="gmu2"></span>
                        &nbsp;&nbsp;净值与回撤.................................................................................................................................................<span
                            class="mulu" data="3"></span></h4>
                    <h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="catalognum_title">5</span>.<span
                            class="gmu2"></span>
                        &nbsp;&nbsp;日净值波动.................................................................................................................................................<span
                            class="mulu" data="4"></span></h4>
                    <h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="catalognum_title">5</span>.<span
                            class="gmu2"></span>
                        &nbsp;&nbsp;累计盈亏与手续费.....................................................................................................................................<span
                            class="mulu" data="5"></span></h4>
                    <h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="catalognum_title">5</span>.<span
                            class="gmu2"></span>
                        &nbsp;&nbsp;当日盈亏与手续费.....................................................................................................................................<span
                            class="mulu" data="6"></span></h4>
                    <h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="catalognum_title">5</span>.<span
                            class="gmu2"></span>
                        &nbsp;&nbsp;逐月盈亏......................................................................................................................................................<span
                            class="mulu" data="7"></span></h4>
                </div>


                <div>
                    <h4>&nbsp;&nbsp;第<span class="catalognum">3</span>部分
                         盈亏分析.....................................................................................................................................................<span
                            class="mulu" data="8"></span></h4>
                    <h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="catalognum_title">5</span>.<span
                            class="gmu3"></span> &nbsp;&nbsp;多空盈亏分析.............................................................................................................................................<span
                            class="mulu" data="16"></span></h4>
                </div>


                <div>
                    <h4>&nbsp;&nbsp;第<span class="catalognum">4</span>部分
                        板块分析.....................................................................................................................................................<span
                            class="mulu" data="101"></span></h4>
                    <h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="catalognum_title">5</span>.<span
                            class="gmu"></span>
                        板块逐月盈亏.............................................................................................................................................<span
                            class="mulu" data="19"></span></h4>
                    <h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="catalognum_title">5</span>.<span
                            class="gmu"></span>
                        成交盈亏占比.............................................................................................................................................<span
                            class="mulu" data="10"></span></h4>
                    <h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="catalognum_title">5</span>.<span
                            class="gmu"></span>
                        板块逐日盈亏.............................................................................................................................................<span
                            class="mulu" data="10"></span></h4>
                    <h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="catalognum_title">5</span>.<span
                            class="gmu"></span>
                        板块逐笔盈亏.............................................................................................................................................<span
                            class="mulu" data="102"></span></h4>
                    <h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="catalognum_title">5</span>.<span
                            class="gmu"></span>
                        品种偏好.....................................................................................................................................................<span
                            class="mulu" data="102"></span></h4>
                    <h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="catalognum_title">5</span>.<span
                            class="gmu"></span>
                        品种逐日盈亏............................................................................................................................................<span
                            class="mulu" data="103"></span></h4>
                    <h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="catalognum_title">5</span>.<span
                            class="gmu"></span>
                        品种逐笔盈亏............................................................................................................................................<span
                            class="mulu" data="103"></span></h4>
                    <h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="catalognum_title">5</span>.<span
                            class="gmu"></span>
                        品种持仓权益............................................................................................................................................<span
                            class="mulu" data="13"></span></h4>
                    <h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="catalognum_title">5</span>.<span
                            class="gmu"></span>
                        板块持仓权益............................................................................................................................................<span
                            class="mulu" data="14"></span></h4>
                    <h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="catalognum_title">5</span>.<span
                            class="gmu"></span>
                        持仓K线......................................................................................................................................................<span
                            class="mulu" data="15"></span></h4>
                    <h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="catalognum_title">5</span>.<span
                            class="gmu"></span>
                        多空持仓保证金........................................................................................................................................<span
                            class="mulu" data="17"></span></h4>
                    <h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="catalognum_title">5</span>.<span
                            class="gmu"></span>
                        板块逐月成交保证金................................................................................................................................<span
                            class="mulu" data="20"></span></h4>
                </div>


                <div>
                    <h4>&nbsp;&nbsp;第<span class="catalognum">5</span>部分
                        周期分析.....................................................................................................................................................<span
                            class="mulu" data="104"></span></h4>
                    <h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="catalognum_title">5</span>.<span
                            class="gmu5"></span>
                        &nbsp;&nbsp;品种周期......................................................................................................................................................<span
                            class="mulu" data="105"></span></h4>
                    <h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="catalognum_title">5</span>.<span
                            class="gmu5"></span>
                        &nbsp;&nbsp;板块周期......................................................................................................................................................<span
                            class="mulu" data="106"></span></h4>
                    <h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="catalognum_title">5</span>.<span
                            class="gmu5"></span>
                        &nbsp;&nbsp;周期盈亏......................................................................................................................................................<span
                            class="mulu" data="21"></span></h4>
                    <h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="catalognum_title">5</span>.<span
                            class="gmu5"></span>
                        &nbsp;&nbsp;周期胜算率..................................................................................................................................................<span
                            class="mulu" data="22"></span></h4>
                </div>


                <div>
                    <h4>&nbsp;&nbsp;第<span class="catalognum">六</span>部分
                        每日评估.....................................................................................................................................................<span
                            class="mulu" data="1"></span></h4>
                </div>

            </div>


            <div class="A4">
                <div class="word-head">
                    <img src="../../../assets/images/report/logo-word.png" />
                    <span class="word-head-title"
                        style="color:#171718 !important;;margin-top: -35px;font-size: 14px;-webkit-transform: scale(0.8);">{{ res.reportStart  }}一{{ res.reportEnd  }}
                        <br />共计{{
              eval.workDayCount
            }}交易日</span>
                    <div class="word-head-right"
                        style="top:4mm;text-align: right;padding-right: 7px;font-size: 12px;-webkit-transform: scale(0.8);">
                        {{ user.phone }} -评估报告
                    </div>
                    <div class="word-footer" style="left:2px;width:200mm">
                        <span style="font-size: 12px;-webkit-transform: scale(0.8);">网址：www.jeesit.com</span>
                        <span class="pagenum"
                            style="color:#171718 !important;font-size:14px;-webkit-transform: scale(0.8);">1/2</span>
                        <span
                            style="text-align: right;font-size: 12px;-webkit-transform: scale(0.8);">导出人：{{ user.name }}</span>
                    </div>
                </div>
                <h2 class="item2 title_font_color" style="font-size: 22pt;text-align: center;font-weight: 600;">
                    第<span class="titlenum part2">2</span>部分 数据分析
                </h2>
                <div style="margin-left: 15px;">
                    <div style="font-size: 12px">
                        交易日期：{{ res.reportStart  }}一{{ res.reportEnd  }}
                    </div>
                    <div class="partone_block" :style="{background:bg,backgroundSize:'100% !important'}">
                        <p class="partone_title" style="margin-top:30px;color:#ffffff !important;">
                            NO.1
                        </p>

                        <p />
                        <p class="partone_title2" style="margin-top:10px;color:#ffffff !important;">
                            盈 利
                        </p>
                    </div>
                    <div class="partone_block">
                        <p class="partone_desc partone_red">当前收益</p>
                        <p class="partone_desc2 partone_red">{{ eval.profitRate|num }}</p>
                    </div>
                    <div class="partone_block">
                        <p class="partone_desc partone_red">年化收益</p>
                        <p class="partone_desc2 partone_red">{{ eval.yearlyProfitRate|num }}</p>
                    </div>
                    <div class="partone_block">
                        <p class="partone_desc partone_red">单日最大盈利</p>
                        <p class="partone_desc2 partone_red">{{ eval.maxDailyProfit|num }}</p>
                    </div>
                    <div class="partone_block">
                        <p class="partone_desc partone_red">夏普比率</p>
                        <p class="partone_desc2 partone_red">{{ eval.sharpeRate |num1}}</p>
                    </div>
                    <div class="partone_block">
                        <p class="partone_desc partone_red">索提诺比率</p>
                        <p class="partone_desc2 partone_red">{{ eval.sortinoRate|num1 }}</p>
                    </div>
                    <div style="clear:both;"></div>
                </div>
                <div style="margin-left: 15px;margin-top:15px;">
                    <div style="font-size: 12px">
                        交易日期：{{ res.reportStart  }}一{{ res.reportEnd  }}
                    </div>
                    <div class="partone_block2" :style="{background:bg2,backgroundSize:'100% !important'}">
                        <p class="partone_title" style="margin-top:30px;color:#ffffff !important;">
                            NO.2
                        </p>

                        <p />
                        <p class="partone_title2" style="margin-top:10px;color:#ffffff !important;">
                            回 撤
                        </p>
                    </div>
                    <div class="partone_block2">
                        <p class="partone_desc partone_green">峰值回撤</p>
                        <p class="partone_desc2 partone_green">{{ eval.maxLoss|num }}</p>
                    </div>
                    <div class="partone_block2">
                        <p class="partone_desc partone_green">本金回撤</p>
                        <p class="partone_desc2 partone_green">{{ eval.capitalLoss|num }}</p>
                    </div>
                    <div class="partone_block2">
                        <p class="partone_desc partone_green">单日最大亏损</p>
                        <p class="partone_desc2 partone_green">{{ eval.maxDailyLosss |num}}</p>
                    </div>
                    <div class="partone_block2">
                        <p class="partone_desc partone_green">最大连续回撤</p>
                        <p class="partone_desc2 partone_green">
                            {{ eval.maxLossContinueTradingDayCount }}
                        </p>
                    </div>
                    <div class="partone_block2">
                        <p class="partone_desc partone_green">最大回撤修复</p>
                        <p class="partone_desc2 partone_green">
                            {{ eval.maxLossRepartTradingDayCount }}
                        </p>
                    </div>
                    <div style="clear:both;"></div>
                </div>
                <div style="margin-left: 15px;margin-top:15px;">
                    <div style="font-size: 12px">
                        交易日期：{{ res.reportStart  }}一{{ res.reportEnd  }}
                    </div>
                    <div class="partone_block3" :style="{background:bg3,backgroundSize:'100% !important'}">
                        <p class="partone_title" style="margin-top:30px;color:#ffffff!important;">
                            NO.3
                        </p>

                        <p />
                        <p class="partone_title2" style="margin-top:10px;color:#ffffff!important;">
                            其 他
                        </p>
                    </div>
                    <div class="partone_block3">
                        <p class="partone_desc partone_blue">卡玛比率</p>
                        <p class="partone_desc2 partone_blue">{{ eval.calmarRate |num1}}</p>
                    </div>
                    <div class="partone_block3">
                        <p class="partone_desc partone_blue">年化波动率</p>
                        <p class="partone_desc2 partone_blue">{{ eval.yearlyWave |num}}</p>
                    </div>
                    <div class="partone_block3">
                        <p class="partone_desc partone_blue">年化下行波动率</p>
                        <p class="partone_desc2 partone_blue">{{ eval.yearlyDownWave |num}}</p>
                    </div>
                    <div class="partone_block3">
                        <p class="partone_desc partone_blue">历史最大净值</p>
                        <p class="partone_desc2 partone_blue">{{ eval.maxNetValue|num }}</p>
                    </div>
                    <div class="partone_block3">
                        <p class="partone_desc partone_blue">重仓失效</p>
                        <p class="partone_desc2 partone_blue">{{ eval.positionFailRate |num}}</p>
                    </div>
                    <div style="clear:both;"></div>
                </div>

                <div style="margin-left:15px;">
                    <br />
                    <span class="partone_red">盈利类指标说明：</span>
                    <p style="font-size: 12px;line-height: 22px">
                        当前收益：统计周期内的绝对收益率；<br />年化收益：统计期内的年化收益率（一般结合账户操作时间与回撤指标来综合考量）；<br />单日最大盈利：统计期内，单个交易日的最大盈利（一般结合单日最大回撤与该投顾的策略来综合考量）；<br />夏普比率：统计周期内的夏普比率，账户风险调整后收益水平以及账户波动率的综合参考指标（目的是计算投资组合每承受一单位总风险，会产生多少的超额报酬）；<br />索提诺比率：统计周期内的索提诺比率，与夏普比率类似，区别在于索提诺比率更注重相同下行风险的波动率（和夏普比率类似，这一比率越高，表明基金承担相同单位下行风险能获得更高的超额回报率）。
                    </p>
                    <span class="partone_green">回撤类指标说明：</span>
                    <p style="font-size: 12px;line-height: 22px">
                        峰值回撤（率）：统计周期内，较前一净值高点的最大回撤比率；<br />本金回撤（率）：统计周期内，期末权益小于账户初始本金的最大回撤金额占初始本金（包含净出入金）的比率（一般作为风险控制方面的参考指标）；<br />单日最大亏损：统计周期内，单个交易日最大亏损；<br />最大连续回撤天数：统计周期内，最大的连续回撤天数；<br />最大回撤修复天数：统计周期内，从前一个净值高点到下一个净值创新高的最大交易天数。
                    </p>
                    <span class="partone_blue">其他类指标说明：</span>
                    <p style="font-size: 12px;line-height: 22px">
                        卡玛比率（收益风险比率）：统计周期内，其绝对收益与最大回撤的比率；<br />年化波动率：：统计周期内，年化最高收益与最低收益的波动比率；<br />年化下行波动率：统计周期内，回撤期间的年化波动比率；<br />历史最大净值：数据统计期内的最高净值；<br />重仓失效率：统计周期内，重仓操作后的回撤比率（一般作为资金管理能力的参考指标）。
                    </p>
                </div>
            </div>



            <div class="A4">
                <div class="word-head">
                    <img src="../../../assets/images/report/logo-word.png" />
                    <span class="word-head-title"
                        style="color:#171718 !important;;margin-top: -35px;font-size: 14px;-webkit-transform: scale(0.8);">{{ res.reportStart  }}一{{ res.reportEnd  }}
                        <br />共计{{
                  eval.workDayCount
                }}交易日</span>
                    <div class="word-head-right"
                        style="top:4mm;text-align: right;padding-right: 7px;font-size: 12px;-webkit-transform: scale(0.8);">
                        {{ user.phone }} -评估报告
                    </div>
                    <div class="word-footer" style="left:2px;width:200mm">
                        <span style="font-size: 12px;-webkit-transform: scale(0.8);">网址：www.jeesit.com</span>
                        <span class="pagenum"
                            style="color:#171718 !important;font-size:14px;-webkit-transform: scale(0.8);">1/2</span>
                        <span
                            style="text-align: right;font-size: 12px;-webkit-transform: scale(0.8);">导出人：{{ user.name }}</span>
                    </div>
                </div>
                <h3 class="item2 title_font_color" style="font-size: 16pt;font-weight: 600;text-align: center;">
                    &nbsp;<span class="part2">1</span>.<span class="small-tip">1</span>
                    净值与持仓
                </h3>
                <div class="panel panel-default">
                    <img v-show ='!show'  style="width: 737px;" :src="main1_base64" alt="">
                    <div v-show ='show' class="panel-body main report" id="main1" style="height: 300px;"></div>
                </div>
                <div class="echarts_details">
                    <div class="summary">
                        账户收益率
                        <span style="font-weight: 600;">{{ eval.profitRate |num}}</span>； 年化收益率<span
                            style="font-weight: 600;">{{
                  eval.yearlyProfitRate|num
                }}</span>； 夏普比率<span style="font-weight: 600;">{{
                  eval.sharpeRate|num1
                }}</span>； 历史最高净值<span style="font-weight: 600;">{{
                  eval.maxNetValue|num2
                }}</span>； 最高持仓占用保证金<span style="font-weight: 600;">{{
                  eval.maxRatioPosition
                }}%</span>； 持仓天数<span style="font-weight: 600;">{{
                  eval.totalDayCount - eval.positionCountEqualZero
                }}</span>； 空仓天数<span style="font-weight: 600;">{{
                  eval.positionCountEqualZero
                }}</span>； 平均持仓占用保证金<span style="font-weight: 600;">{{
                  eval.avgPosition|num
                }}</span>
                    </div>
                </div>
             

                <h3 class="item3 title_font_color" style="font-size: 16pt;font-weight: 600;text-align: center;">
                    &nbsp;<span class="part2">1</span>.<span class="small-tip">3</span>
                    净值与回撤
                </h3>
                <div class="panel panel-default">
                    <img v-show ='!show'  style="width: 737px;":src="main2_base64" alt="">
                    <div v-show ='show' class="panel-body main report" id="main2"></div>
                </div>
                <div class="echarts_details">
                    <div class="summary">
                        历史最大回撤 <span style="font-weight: 600;">{{ eval.maxLoss|num }}</span>； 单日最大回撤
                        <span style="font-weight: 600;">{{ eval.maxDailyLosss |num}}</span>； 本金回撤
                        <span style="font-weight: 600;">{{ eval.capitalLoss |num}}</span>； 最大连续回撤
                        <span style="font-weight: 600;">{{
                  eval.maxLossContinueTradingDayCount
                }}</span>
                        天； 最大回撤期为 {{ eval.maxLossPreMaxNetTradingDay }} 至
                        {{ eval.maxLossTradingDay }}，共计
                        {{ eval.maxLossIndex - eval.maxLossPreMaxNetIndex + 1 }} 个交易日
                    </div>
                </div>
            </div>


            <div class="A4">
                <div class="word-head">
                    <img src="../../../assets/images/report/logo-word.png" />
                    <span class="word-head-title"
                        style="color:#171718 !important;;margin-top: -35px;font-size: 14px;-webkit-transform: scale(0.8);">{{ res.reportStart  }}一{{ res.reportEnd  }}
                        <br />共计{{
                  eval.workDayCount
                }}交易日</span>
                    <div class="word-head-right"
                        style="top:4mm;text-align: right;padding-right: 7px;font-size: 12px;-webkit-transform: scale(0.8);">
                        {{ user.phone }} -评估报告
                    </div>
                    <div class="word-footer" style="left:2px;width:200mm">
                        <span style="font-size: 12px;-webkit-transform: scale(0.8);">网址：www.jeesit.com</span>
                        <span class="pagenum"
                            style="color:#171718 !important;font-size:14px;-webkit-transform: scale(0.8);">1/2</span>
                        <span
                            style="text-align: right;font-size: 12px;-webkit-transform: scale(0.8);">导出人：{{ user.name }}</span>
                    </div>
                </div>
                
                <h3 class="item4 title_font_color" style="font-size: 16pt;font-weight: 600;text-align: center;">
                    &nbsp;<span class="part2">1</span>.<span class="small-tip">4</span>
                    日净值波动
                </h3>
                <div class="panel panel-default">
                    <img v-show ='!show'  style="width: 737px;":src="main3_base64" alt="">
                    <div v-show ='show' class="panel-body main report" id="main3"></div>
                </div>
                <div class="echarts_details">
                    <div class="summary">
                        账户峰值波动率为 <span style="font-weight: 600;">{{eval.maxDailyProfit|num}}</span>；
                        年化波动率 <span style="font-weight: 600;">{{eval.yearlyWave|num}}</span>
                    </div>
                </div>
                <h3 class="item5 title_font_color" style="font-size: 16pt;font-weight: 600;text-align: center;">
                    &nbsp;<span class="part2">1</span>.<span class="small-tip">3</span>
                    累计盈亏与手续费
                </h3>
                <div class="panel panel-default">
                    <img v-show ='!show'  style="width: 737px;":src="main4_base64" alt="">
                    <div v-show ='show' class="panel-body main report" id="main4"></div>
                </div>
                <div class="echarts_details">
                    <div class="summary">
                        累计手续费 <span style="font-weight: 600;">{{(eval.datas?eval.datas[0].sumCommosion:'')|money}}</span> 元；
                        手续费占总盈利 <span style="font-weight: 600;">{{eval.commosionOfSumProfit|num}}</span>；
                        累计盈亏 <span
                            style="font-weight: 600;">{{(eval.sumProfitArray?eval.sumProfitArray[eval.sumProfitArray-1]:'')|money}}</span>
                        元；
                        最大累计盈利 <span  style="font-weight: 600;">{{eval.maxsumProfit|money}}</span>
                        元；
                       
                    </div>
                </div>

            </div>
            <div class="A4">
                <div class="word-head">
                    <img src="../../../assets/images/report/logo-word.png" />
                    <span class="word-head-title"
                        style="color:#171718 !important;;margin-top: -35px;font-size: 14px;-webkit-transform: scale(0.8);">{{ res.reportStart  }}一{{ res.reportEnd  }}
                        <br />共计{{
                  eval.workDayCount
                }}交易日</span>
                    <div class="word-head-right"
                        style="top:4mm;text-align: right;padding-right: 7px;font-size: 12px;-webkit-transform: scale(0.8);">
                        {{ user.phone }} -评估报告
                    </div>
                    <div class="word-footer" style="left:2px;width:200mm">
                        <span style="font-size: 12px;-webkit-transform: scale(0.8);">网址：www.jeesit.com</span>
                        <span class="pagenum"
                            style="color:#171718 !important;font-size:14px;-webkit-transform: scale(0.8);">1/2</span>
                        <span
                            style="text-align: right;font-size: 12px;-webkit-transform: scale(0.8);">导出人：{{ user.name }}</span>
                    </div>
                </div>
              
    
                <h3 class="item6 title_font_color" style="font-size: 16pt;font-weight: 600;text-align: center;">
                    &nbsp;<span class="part2">1</span>.<span class="small-tip">4</span>
                    当日盈亏与手续费
                </h3>
                <div class="panel panel-default">
                    <img  v-show ='!show'  style="width: 737px;":src="main8_base64" alt="">
                    <div v-show ='show' class="panel-body main report" id="main8"></div>
                </div>
                <div class="echarts_details">
                    <div class="summary">
                        最大单日盈利 <span style="font-weight: 600;">{{eval.maxCurrentProfit|money}}</span> 元；
                        最大单日亏损 <span style="font-weight: 600;">{{-eval.maxCurrentLoss|money}}</span> 元；
                        最大单日手续费 <span style="font-weight: 600;">{{eval.maxCurrentCommission|money}}</span> 元；
                        每日平均手续费 <span style="font-weight: 600;">{{eval.aveCommosion|money}}</span> 元
                    </div>
                </div>
                <h3 class="item7 title_font_color" style="font-size: 16pt;font-weight: 600;text-align: center;">
                    &nbsp;<span class="part2">1</span>.<span class="small-tip">6</span>
                    逐月盈亏
                </h3>
                <br />
                <div class="panel panel-default">
                    <img v-show ='!show'  style="width: 737px;":src="main18_base64" alt="">
                    <div v-show ='show' class="panel-body main report" id="main18_1"></div>
                </div>

            </div>
    
    
    
    
            <div class="A4" style="line-height: normal;">
    
    
    
    
    
    
                <div class="word-head">
                    <img src="../../../assets/images/report/logo-word.png" />
                    <span class="word-head-title"
                        style="color:#171718 !important;;margin-top: -35px;font-size: 14px;-webkit-transform: scale(0.8);">{{ res.reportStart  }}一{{ res.reportEnd  }}
                        <br />共计{{
                    eval.workDayCount
                  }}交易日</span>
                    <div class="word-head-right"
                        style="top:4mm;text-align: right;padding-right: 7px;font-size: 12px;-webkit-transform: scale(0.8);">
    
                        {{user.phone}} -评估报告
                    </div>
                    <div class="word-footer" style="left:2px;width:200mm">
                        <span style="font-size: 12px;-webkit-transform: scale(0.8);">网址：www.jeesit.com</span>
                        <span class="pagenum"
                            style="color:#171718 !important;font-size:14px;-webkit-transform: scale(0.8);">1/2</span>
                        <span
                            style="text-align: right;font-size: 12px;-webkit-transform: scale(0.8);">导出人：{{user.name}}</span>
                    </div>
                </div>
                <h2 class="item8 title_font_color" style="font-size: 22pt;text-align: center;font-weight: 600;">第<span
                        class="titlenum part3">3</span>部分 盈亏分析</h2>
                <div style="margin:auto 30px;">
                    <div
                        style="margin: 10px 0px 20px 0px;border:1px #E2E4E8 solid;border-radius: 5px;">
                        <div
                            style="color:#141516!important;font-size:16px;font-weight: 600;text-align: center;margin-top: 10px;margin-bottom: 5px">
                            平仓总盈利（逐笔）</div>
                        <div
                            :style="{fontSize:'20px',textAlign: 'center',color:pro.collectTotalPorfit>0?'#F43131 !important':'#27BD71 !important'}">
                            {{pro.collectTotalPorfit|money}}</div>
                        <hr style="margin-top:10px;margin-bottom: 10px" />
                        <div class="data_block_padding">
                            <div style="width:32%;display: inline-block;">
                                <div
                                    style="width: 105px;height: 55px;background: #F1F8FF!important;border: 1px solid #68A0F4!important;text-align: center;">
                                    <p style="color:#3891EC!important;font-size:14px;margin-bottom:5px;margin-top:5px;">总手数
                                    </p>
                                    <p style="color:#1E80EE!important;font-size:20px;">{{pro.collectSumCount}}</p>
                                </div>
                            </div>
                            <div style="width:33%;display: inline-block;">
                                <div
                                    style="width: 105px;height: 55px;background: #FFFCF1!important;border: 1px solid #FDB763!important;text-align: center;margin:auto;">
                                    <p style="color:#FFA44B!important;font-size:14px;margin-bottom:5px;margin-top:5px;">胜率
                                    </p>
                                    <p style="color:#FF942B!important;font-size:20px;">{{pro.collectwinRate}}%</p>
                                </div>
                            </div>
                            <div style="width:32%;display: inline-block;text-align: right;">
                                <div
                                    style="width: 105px;height: 55px;border: 1px solid #F96767!important;text-align: center;display: inline-block;">
                                    <p style="color:#F05050!important;font-size:14px;margin-bottom:5px;margin-top:5px;">盈亏比
                                    </p>
                                    <p style="color:#F43131!important;font-size:20px;">{{pro.collectPorfitLossRate}}</p>
                                </div>
                            </div>
                        </div>
                        <div style="margin-top:10px;" class="data_block_padding">
                            <div style="width:32%;display: inline-block;">
                                <div style="">
                                    <p class="data_block_font">交易盈利次数</p>
                                    <p class="data_p_margin_bottom" style="color:#141516!important;font-size:14px;">
                                        {{pro.collectGainCount}}</p>
                                </div>
                            </div>
                            <div style="width:33%;display: inline-block;">
                                <div style="text-align: center;margin:auto;">
                                    <p class="data_block_font">合计盈利</p>
                                    <p class="data_p_margin_bottom"
                                        :style="{color:'#141516 !important',fontSize:'14px',color:pro.collectSumPortfit>0?'#F43131 !important':'#27BD71 !important'}">
                                        {{pro.collectSumPortfit|money}}</p>
                                </div>
                            </div>
                            <div style="width:32%;display: inline-block;text-align: right;">
                                <div style="text-align: right;display: inline-block;">
                                    <p class="data_block_font">每笔平均盈利</p>
                                    <p class="data_p_margin_bottom"
                                        :style="{color:'#141516 !important',fontSize:'14px',color:pro.collectAvgPorfit>0?'#F43131 !important':'#27BD71 !important'}">
                                        {{pro.collectAvgPorfit|money}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="data_block_padding">
                            <div style="width:32%;display: inline-block;">
                                <div style="">
                                    <p class="data_block_font">交易亏损次数</p>
                                    <p class="data_p_margin_bottom" style="color:#141516 !important;font-size:14px;">
                                        {{pro.collectLossCount}}</p>
                                </div>
                            </div>
                            <div style="width:33%;display: inline-block;">
                                <div style="text-align: center;margin:auto;">
                                    <p class="data_block_font">合计亏损</p>
                                    <p class="data_p_margin_bottom"
                                        :style="{color:'#141516 !important',fontSize:'14px',color:pro.collectSumLoss>0?'#F43131 !important':'#27BD71 !important'}">
                                        {{pro.collectSumLoss|money}}</p>
                                </div>
                            </div>
                            <div style="width:32%;display: inline-block;text-align: right;">
                                <div style="text-align: right;display: inline-block;">
                                    <p class="data_block_font">每笔平均亏损</p>
                                    <p class="data_p_margin_bottom"
                                        :style="{color:'#141516 !important',fontSize:'14px',color:pro.collectAvgLoss>0?'#F43131 !important':'#27BD71 !important'}">
                                        {{pro.collectAvgLoss|money}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="data_block_padding">
                            <div style="width:32%;display: inline-block;">
                                <div style="">
                                    <p class="data_block_font">交易持平次数</p>
                                    <p class="data_p_margin_bottom5" style="color:#141516!important;font-size:14px;">
                                        {{pro.collectEqualCount}}</p>
                                </div>
                            </div>
                            <div style="width:33%;display: inline-block;">
                                <div style="text-align: center;margin:auto;">
                                    <p class="data_block_font">合计持平</p>
                                    <p class="data_p_margin_bottom5" style="color:#141516!important;font-size:14px;">0</p>
                                </div>
                            </div>
                            <div style="width:32%;display: inline-block;text-align: right;">
                                <div style="text-align: right;display: inline-block;">
                                    <p class="data_block_font">每笔平均持平</p>
                                    <p class="data_p_margin_bottom5" style="color:#141516!important;font-size:14px;">0</p>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <div
                        style="margin: 10px 0px 20px 0px;border:1px #E2E4E8 solid;border-radius: 5px;">
                        <div
                            style="color:#141516!important;font-size:16px;font-weight: 600;text-align: center;margin-top: 10px;margin-bottom: 5px">
                            多头平仓盈利（逐笔）</div>
                        <div
                            :style="{fontSize:'20px',textAlign: 'center',marginBottom: '10px',color:pro.toltalLongPorfit>0?'#F43131 !important':'#27BD71 !important'}">
                            {{pro.toltalLongPorfit|money}}</div>
                        <hr style="margin-top:10px;margin-bottom: 10px;" />
                        <div class="data_block_padding">
                            <div style="width:32%;display: inline-block;">
                                <div
                                    style="width: 105px;height: 55px;background: #F1F8FF!important;border: 1px solid #68A0F4!important;text-align: center;">
                                    <p style="color:#3891EC!important;font-size:14px;margin-bottom:5px;margin-top:5px;">总手数
                                    </p>
                                    <p style="color:#1E80EE!important;font-size:20px;">{{pro.toltalLongCount}}</p>
                                </div>
                            </div>
                            <div style="width:33%;display: inline-block;">
                                <div
                                    style="width: 105px;height: 55px;background: #FFFCF1!important;border: 1px solid #FDB763!important;text-align: center;margin:auto;">
                                    <p style="color:#FFA44B!important;font-size:14px;margin-bottom:5px;margin-top:5px;">胜率
                                    </p>
                                    <p style="color:#FF942B!important;font-size:20px;">{{pro.longwinRate}}%</p>
                                </div>
                            </div>
                            <div style="width:32%;display: inline-block;text-align: right;">
                                <div
                                    style="width: 105px;height: 55px;border: 1px solid #F96767!important;text-align: center;display: inline-block;">
                                    <p style="color:#F05050!important;font-size:14px;margin-bottom:5px;margin-top:5px;">盈亏比
                                    </p>
                                    <p style="color:#F43131!important;font-size:20px;">{{pro.longProfitLossRate}}</p>
                                </div>
                            </div>
                        </div>
                        <div style="margin-top:10px;" class="data_block_padding">
                            <div style="width:32%;display: inline-block;">
                                <div style="">
                                    <p class="data_block_font">交易盈利次数</p>
                                    <p class="data_p_margin_bottom" style="color:#141516!important;font-size:14px;">
                                        {{pro.sumLongGainCount}}</p>
                                </div>
                            </div>
                            <div style="width:33%;display: inline-block;">
                                <div style="text-align: center;margin:auto;">
                                    <p class="data_block_font">合计盈利</p>
                                    <p class="data_p_margin_bottom"
                                        :style="{color:'#141516 !important',fontSize:'14px',color:pro.sumLongGainAmount>0?'#F43131 !important':'#27BD71 !important'}">
                                        {{pro.sumLongGainAmount|money}}</p>
                                </div>
                            </div>
                            <div style="width:32%;display: inline-block;text-align: right;">
                                <div style="text-align: right;display: inline-block;">
                                    <p class="data_block_font">每笔平均盈利</p>
                                    <p class="data_p_margin_bottom"
                                        :style="{color:'#141516 !important',fontSize:'14px',color:pro.longAvgPorfit>0?'#F43131 !important':'#27BD71 !important'}">
                                        {{pro.longAvgPorfit|money}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="data_block_padding">
                            <div style="width:32%;display: inline-block;">
                                <div style="">
                                    <p class="data_block_font">交易亏损次数</p>
                                    <p class="data_p_margin_bottom" style="color:#141516 !important;font-size:14px;">
                                        {{pro.sumLongLossCount}}</p>
                                </div>
                            </div>
                            <div style="width:33%;display: inline-block;">
                                <div style="text-align: center;margin:auto;">
                                    <p class="data_block_font">合计亏损</p>
                                    <p class="data_p_margin_bottom"
                                        :style="{color:'#141516 !important',fontSize:'14px',color:pro.sumLongLossAmount>0?'#F43131 !important':'#27BD71 !important'}">
                                        {{pro.sumLongLossAmount|money}}</p>
                                </div>
                            </div>
                            <div style="width:32%;display: inline-block;text-align: right;">
                                <div style="text-align: right;display: inline-block;">
                                    <p class="data_block_font">每笔平均亏损</p>
                                    <p class="data_p_margin_bottom"
                                        :style="{color:'#141516 !important',fontSize:'14px',color:pro.longAvgLoss>0?'#F43131 !important':'#27BD71 !important'}">
                                        {{pro.longAvgLoss|money}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="data_block_padding">
                            <div style="width:32%;display: inline-block;">
                                <div style="">
                                    <p class="data_block_font">交易持平次数</p>
                                    <p class="data_p_margin_bottom5" style="color:#141516 !important;font-size:14px;">
                                        {{pro.sumLongEqualCount}}</p>
                                </div>
                            </div>
                            <div style="width:33%;display: inline-block;">
                                <div style="text-align: center;margin:auto;">
                                    <p class="data_block_font">合计持平</p>
                                    <p class="data_p_margin_bottom5" style="color:#141516 !important;font-size:14px;">0</p>
                                </div>
                            </div>
                            <div style="width:32%;display: inline-block;text-align: right;">
                                <div style="text-align: right;display: inline-block;">
                                    <p class="data_block_font">每笔平均持平</p>
                                    <p class="data_p_margin_bottom5" style="color:#141516 !important;font-size:14px;">0</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        style="margin: 10px 0px 20px 0px;border:1px #E2E4E8 solid;border-radius: 5px;">
                        <div
                            style="color:#141516!important;font-size:16px;margin-top: 10px;margin-bottom: 5px;font-weight: 600;text-align: center;">
                            空头平仓盈利（逐笔）</div>
                        <div
                            :style="{color:'#F43131 !important',textAlign: 'center',marginBottom: '10px',fontSize:'20px',color:pro.toltalShortPorfit>0?'#F43131 !important':'#27BD71 !important'}">
                            {{pro.toltalShortPorfit|money}}</div>
                        <hr style="margin-top:10px;margin-bottom: 10px" />
                        <div class="data_block_padding">
                            <div style="width:32%;display: inline-block;">
                                <div
                                    style="width: 105px;height: 55px;background: #F1F8FF!important;border: 1px solid #68A0F4!important;text-align: center;">
                                    <p style="color:#3891EC!important;font-size:14px;margin-bottom:5px;margin-top:5px;">总手数
                                    </p>
                                    <p style="color:#1E80EE!important;font-size:20px;">{{pro.toltalShortCount}}</p>
                                </div>
                            </div>
                            <div style="width:33%;display: inline-block;">
                                <div
                                    style="width: 105px;height: 55px;background: #FFFCF1!important;border: 1px solid #FDB763!important;text-align: center;margin:auto;">
                                    <p style="color:#FFA44B!important;font-size:14px;margin-bottom:5px;margin-top:5px;">胜率
                                    </p>
                                    <p style="color:#FF942B!important;font-size:20px;">{{pro.shortwinRate}}%</p>
                                </div>
                            </div>
                            <div style="width:32%;display: inline-block;text-align: right;">
                                <div
                                    style="width: 105px;height: 55px;border: 1px solid #F96767!important;text-align: center;display: inline-block;">
                                    <p style="color:#F05050!important;font-size:14px;margin-bottom:5px;margin-top:5px;">盈亏比
                                    </p>
                                    <p style="color:#F43131!important;font-size:20px;">{{pro.shortProfitLossRate}}</p>
                                </div>
                            </div>
                        </div>
                        <div style="margin-top:10px;" class="data_block_padding">
                            <div style="width:32%;display: inline-block;">
                                <div style="">
                                    <p class="data_block_font">交易盈利次数</p>
                                    <p class="data_p_margin_bottom" style="color:#141516!important;font-size:14px;">
                                        {{pro.sumShortGainCount}}</p>
                                </div>
                            </div>
                            <div style="width:33%;display: inline-block;">
                                <div style="text-align: center;margin:auto;">
                                    <p class="data_block_font">合计盈利</p>
                                    <p class="data_p_margin_bottom"
                                        :style="{color:'#141516 !important',fontSize:'14px',color:pro.sumShortGainAmount>0?'#F43131 !important':'#27BD71 !important'}">
                                        {{pro.sumShortGainAmount|money}}</p>
                                </div>
                            </div>
                            <div style="width:32%;display: inline-block;text-align: right;">
                                <div style="text-align: right;display: inline-block;">
                                    <p class="data_block_font">每笔平均盈利</p>
                                    <p class="data_p_margin_bottom"
                                        :style="{color:'#141516 !important',fontSize:'14px',color:pro.shortAvgPorfit>0?'#F43131 !important':'#27BD71 !important'}">
                                        {{pro.shortAvgPorfit}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="data_block_padding">
                            <div style="width:32%;display: inline-block;">
                                <div style="">
                                    <p class="data_block_font">交易亏损次数</p>
                                    <p class="data_p_margin_bottom" style="color:#141516!important;font-size:14px;">
                                        {{pro.sumShortLossCount}}</p>
                                </div>
                            </div>
                            <div style="width:33%;display: inline-block;">
                                <div style="text-align: center;margin:auto;">
                                    <p class="data_block_font">合计亏损</p>
                                    <p class="data_p_margin_bottom"
                                        :style="{color:'#141516 !important',fontSize:'14px',color:pro.sumShortLossAmount>0?'#F43131 !important':'#27BD71 !important'}">
                                        {{pro.sumShortLossAmount|money}}</p>
                                </div>
                            </div>
                            <div style="width:32%;display: inline-block;text-align: right;">
                                <div style="text-align: right;display: inline-block;">
                                    <p class="data_block_font">每笔平均亏损</p>
                                    <p class="data_p_margin_bottom"
                                        :style="{color:'#141516 !important',fontSize:'14px',color:pro.shortAvgLoss>0?'#F43131 !important':'#27BD71 !important'}">
                                        {{pro.shortAvgLoss|money}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="data_block_padding">
                            <div style="width:32%;display: inline-block;">
                                <div style="">
                                    <p class="data_block_font">交易持平次数</p>
                                    <p class="data_p_margin_bottom5" style="color:#141516!important;font-size:14px;">
                                        {{pro.sumShortEqualCount}}</p>
                                </div>
                            </div>
                            <div style="width:33%;display: inline-block;">
                                <div style="text-align: center;margin:auto;">
                                    <p class="data_block_font">合计持平</p>
                                    <p class="data_p_margin_bottom5" style="color:#141516!important;font-size:14px;">0</p>
                                </div>
                            </div>
                            <div style="width:32%;display: inline-block;text-align: right;">
                                <div style="text-align: right;display: inline-block;">
                                    <p class="data_block_font">每笔平均持平</p>
                                    <p class="data_p_margin_bottom5" style="color:#141516!important;font-size:14px;">0</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
            <div class="A4">
    
    
    
    
    
    
                <div class="word-head">
                    <img src="../../../assets/images/report/logo-word.png" />
                    <span class="word-head-title"
                        style="color:#171718 !important;;margin-top: -35px;font-size: 14px;-webkit-transform: scale(0.8);">{{ res.reportStart  }}一{{ res.reportEnd  }}
                        <br />共计{{
                  eval.workDayCount
                }}交易日</span>
                    <div class="word-head-right"
                        style="top:4mm;text-align: right;padding-right: 7px;font-size: 12px;-webkit-transform: scale(0.8);">
    
                        {{user.phone}} -评估报告
                    </div>
                    <div class="word-footer" style="left:2px;width:200mm">
                        <span style="font-size: 12px;-webkit-transform: scale(0.8);">网址：www.jeesit.com</span>
                        <span class="pagenum"
                            style="color:#171718 !important;font-size:14px;-webkit-transform: scale(0.8);">1/2</span>
                        <span
                            style="text-align: right;font-size: 12px;-webkit-transform: scale(0.8);">导出人：{{user.name}}</span>
                    </div>
                </div>
                <h3 class="item16 title_font_color" style="font-size: 16pt;font-weight: 600;text-align: center;">&nbsp;<span
                        class="part3">3</span>.<span class="small-tip3">3</span> 多空盈亏分析</h3>
                <div class="panel panel-default">
                    <img v-show ='!show'  style="width: 737px;":src="main16_base64" alt="">
                    <div v-show ='show' class="panel-body main report" id="main16_1" style="height: 700px;">
                    </div>
                </div>
            </div>
    
    
            <div class="A4 A4_p">
    
    
    
    
    
    
                <div class="word-head">
                    <img src="../../../assets/images/report/logo-word.png" />
                    <span class="word-head-title"
                        style="color:#171718 !important;;margin-top: -35px;font-size: 14px;-webkit-transform: scale(0.8);">{{ res.reportStart  }}一{{ res.reportEnd  }}
                        <br />共计{{
                  eval.workDayCount
                }}交易日</span>
                    <div class="word-head-right"
                        style="top:4mm;text-align: right;padding-right: 7px;font-size: 12px;-webkit-transform: scale(0.8);">
    
                        {{user.phone}} -评估报告
                    </div>
                    <div class="word-footer" style="left:2px;width:200mm">
                        <span style="font-size: 12px;-webkit-transform: scale(0.8);">网址：www.jeesit.com</span>
                        <span class="pagenum"
                            style="color:#171718 !important;font-size:14px;-webkit-transform: scale(0.8);">1/2</span>
                        <span
                            style="text-align: right;font-size: 12px;-webkit-transform: scale(0.8);">导出人：{{user.name}}</span>
                    </div>
                </div>
                <h2 class="item101 title_font_color" style="font-size: 22pt;text-align: center;font-weight: 600;">第<span
                        class="titlenum part4">4</span>部分 板块分析</h2>
                <div style="margin: 0px 20px 20px 20px ;">
                    <p style="color:#F14D4D !important;font-size: 12px;">* 交易涉及
                        <span v-for="(item,index) in eval.topPlateName" :key=index>{{item}}、</span>
    
    
                        等{{eval.countPlate}}个板块</p>
                </div>
    
                <div class="block_msg" style="margin: 0px 20px 20px 20px ; height:109px;font-size: 12px;display: flex;justify-content: space-around;align-items: center;border:1px #E2E4E8 solid;border-radius: 5px !important;text-align: center;">
                    <li>
                        <span style="font-size: 22px;">{{eval.productNum}}</span>
                        <p style="margin-top: 15px;">总交易品种</p>
                    </li>
                    <li>
                        <span style="color: #f14d4d !important;font-size: 22px;">{{eval.countProfit}}</span>
                        <p style="margin-top: 15px;">盈利品种</p>
                    </li>
    
                    <li>
                        <span style="color: #27bd71 !important;font-size: 22px;">{{eval.countLoss}}</span>
                        <p style="margin-top: 15px;">亏损品种</p>
                    </li>
    
                    <li>
                        <span style="color: #468bf1 !important;font-size: 22px;">{{eval.profitLossRatio}}</span>
                        <p style="margin-top: 15px;">品种盈亏比</p>
                    </li>
    
                    <li>
                        <span style="font-size: 22px;">{{eval.maxProductInHand?"暂无":eval.maxProductInHand}}</span>
                        <p style="margin-top: 15px;">交易手数最多品种</p>
                    </li>
    
                    <li>
                        <span style="font-size: 22px;">{{eval.plateRatioArray?eval.plateRatioArray[0].name?"暂无":eval.plateRatioArray[0].name:''}}</span>
                        <p style="margin-top: 15px;">持仓占用保证金最高品种</p>
                    </li>
                </div>
    
                <div class="block_box">
                    <li>
                        <p class="block_box_t">
                            <span>盈利最高板块：{{eval.maxPlateProfit?"暂无":eval.maxPlateProfit}}</span>
                            <!-- <img src="../../../assets/images/report/1a.png" alt="" /> -->
                        </p>
                        <div>
                            <img src="../../../assets/images/report/1.png" alt="" style="width: 80px;height: 70px;margin-right: 10px;" />
                            <p class="right_p">
                                <span>占总盈利：</span><br/>
                                <b style="color: #F14D4D !important;font-size: 36px;font-weight: 400;">{{eval.ratioPlateInSumProfit}}%</b>
                            </p>
                        </div>
                    </li>
                    <li style="margin-left: 0px">
                        <p class="block_box_t">
                            <span>亏损最大板块：{{eval.maxPlateLoss?"暂无":eval.maxPlateLoss}}</span>
                            <!-- <img src="../../../assets/images/report/2a.png" alt="" /> -->
                        </p>
                        <div>
                            <img style="width: 80px;height: 80px;margin-right: 10px;" src="../../../assets/images/report/21.png" alt="" />
                            <p class="right_p">
                                <span>占总亏损：</span><br/>
                                <b style="color: #32B977 !important;font-size: 36px;font-weight: 400;">{{eval.ratioPlateInSumLoss}}%</b>
                            </p>
                        </div>
                    </li>
                </div>
                <div class="block_box">
                    <li>
                        <p class="block_box_t">
                            <span>盈利最高品种:{{eval.maxProductProfit?"暂无":eval.maxProductProfit}}</span>
                            <b style="float: right;
                            margin: 0 15px 0 0;
                            font-size: 14px;
                            color: #5d646e;
                            line-height: 56px;
                            font-weight: 400;">以逐笔盈亏计算</b>
                            <!-- <img src="../../../assets/images/report/3a.png" alt="" /> -->
                        </p>
                        <div>
                            <img style="width: 80px;height: 80px;margin-right: 10px;" src="../../../assets/images/report/3.png" alt="" />
                            <span class="right_p">
                                <p class="profit" style="margin-bottom: -10px;font-size: 14px;">盈利：<em
                                        style="font-size: 24px;font-style:normal;color: #F14D4D !important;">￥{{eval.maxProductProfitMoney|money}}</em>
                                </p>
                                <p class="profit_" style="font-size: 14px;">占总盈利：<em
                                        style="font-size: 36px;font-style:normal;color: #F14D4D !important;">{{eval.ratioInSumProfit}}%</em>
                                </p>
                            </span>
                        </div>
                    </li>
    
                    <li style="margin-left: 0px">
                        <p class="block_box_t">
                            <span>亏损最大品种:{{eval.maxProductLoss?"暂无":eval.maxProductLoss}}</span>
                            <b style="float: right;
                            margin: 0 15px 0 0;
                            font-size: 14px;
                            color: #5d646e;
                            line-height: 56px;
                            font-weight: 400;">以逐笔盈亏计算</b>
                            <!-- <img src="../../../assets/images/report/4a.png" alt="" /> -->
                        </p>
                        <div>
                            <img style="width: 72px;height: 70px;margin-right: 10px;" src="../../../assets/images/report/4.png" alt="" />
                            <span class="right_p">
                                <p class="profit" style="margin-bottom: -10px;font-size: 14px;">亏损：<em
                                        style="font-size: 24px;font-style:normal;color: #32B977 !important;">￥{{eval.maxProductLossMoney}}</em>
                                </p>
                                <p class="profit_" style="font-size: 14px;">占总亏损：<em
                                        style="font-size: 36px;font-style:normal;color: #32B977 !important;">{{eval.ratioInSumLoss}}%</em>
                                </p>
                            </span>
                        </div>
                    </li>
                </div>
                <h3 class="item19 title_font_color" style="font-size: 16pt;font-weight: 600;text-align: center;">&nbsp;<span
                        class="part4">6</span>.<span class="small-tip4">6</span> 板块逐月盈亏</h3>
                <div class="panel panel-default">
                    <img v-show ='!show'  style="width: 737px;":src="main19_base64" alt="">
                    <div v-show ='show' class="panel-body main report" id="main19_1">
                    </div>
                </div>
    
            </div>
            <div class="A4">
    
    
    
    
    
    
                <div class="word-head">
                    <img src="../../../assets/images/report/logo-word.png" />
                    <span class="word-head-title"
                        style="color:#171718 !important;;margin-top: -35px;font-size: 14px;-webkit-transform: scale(0.8);">{{ res.reportStart  }}一{{ res.reportEnd  }}
                        <br />共计{{
                  eval.workDayCount
                }}交易日</span>
                    <div class="word-head-right"
                        style="top:4mm;text-align: right;padding-right: 7px;font-size: 12px;-webkit-transform: scale(0.8);">
    
                        {{user.phone}} -评估报告
                    </div>
                    <div class="word-footer" style="left:2px;width:200mm">
                        <span style="font-size: 12px;-webkit-transform: scale(0.8);">网址：www.jeesit.com</span>
                        <span class="pagenum"
                            style="color:#171718 !important;font-size:14px;-webkit-transform: scale(0.8);">1/2</span>
                        <span
                            style="text-align: right;font-size: 12px;-webkit-transform: scale(0.8);">导出人：{{user.name}}</span>
                    </div>
                </div>
                <h3 class="item10 title_font_color" style="font-size: 16pt;font-weight: 600;text-align: center;">&nbsp;<span
                        class="part4">6</span>.<span class="small-tip4">6</span> 成交盈亏占比</h3>
                <br>
                <div class="panel panel-default">
                    <img v-show ='!show'  style="width: 737px;":src="main12_base64" alt="">
                    <div v-show ='show' class="panel-body main report" id="main12">
                    </div>
                </div>
                <div class="echarts_details">
                    <div class="summary">
                        最大成交额占比 <span style="font-weight: 600;">{{pro.maxbargainLimitName}} {{pro.maxbargainLimit}}%</span>；
                        最小成交额占比 <span style="font-weight: 600;">{{pro.minbargainLimitName}} {{pro.minbargainLimit}}%</span>；
                        最大盈亏占比 <span style="font-weight: 600;">{{pro.maxbargainPLName}} {{pro.maxbargainPL}}%</span>；
                        最小盈亏占比 <span style="font-weight: 600;">{{pro.minbargainPLName}} {{pro.minbargainPL}}%</span>
                    </div>
                </div>
                <h3 class="item10 title_font_color" style="font-size: 16pt;font-weight: 600;text-align: center;">&nbsp;<span
                        class="part4">6</span>.<span class="small-tip4">6</span> 板块逐日盈亏</h3>
                <div class="panel panel-default">
                    <img v-show ='!show'  style="width: 737px;":src="main10_base64" alt="">
                    <div v-show ='show' class="panel-body main report" id="main10">
                    </div>
                </div>
            </div>
            <div class="A4">
    
    
    
    
    
    
                <div class="word-head">
                    <img src="../../../assets/images/report/logo-word.png" />
                    <span class="word-head-title"
                        style="color:#171718 !important;;margin-top: -35px;font-size: 14px;-webkit-transform: scale(0.8);">{{ res.reportStart  }}一{{ res.reportEnd  }}
                        <br />共计{{
                  eval.workDayCount
                }}交易日</span>
                    <div class="word-head-right"
                        style="top:4mm;text-align: right;padding-right: 7px;font-size: 12px;-webkit-transform: scale(0.8);">
    
                        {{user.phone}} -评估报告
                    </div>
                    <div class="word-footer" style="left:2px;width:200mm">
                        <span style="font-size: 12px;-webkit-transform: scale(0.8);">网址：www.jeesit.com</span>
                        <span class="pagenum"
                            style="color:#171718 !important;font-size:14px;-webkit-transform: scale(0.8);">1/2</span>
                        <span
                            style="text-align: right;font-size: 12px;-webkit-transform: scale(0.8);">导出人：{{user.name}}</span>
                    </div>
                </div>
                <h3 class="item102 title_font_color" style="font-size: 16pt;font-weight: 600;text-align: center;margin:0px">
                    &nbsp;<span class="part4">6</span>.<span class="small-tip4">6</span> 板块逐笔盈亏</h3>
                <div class="panel panel-default">
                    <img v-show ='!show'  style="width: 737px;":src="main9_base64" alt="">
                    <div v-show ='show' class="panel-body main report" id="main9"
                        style="height: 270px;padding-top: 0px;padding-bottom: 10px">
                    </div>
                </div>
                <div class="echarts_details">
                    <div class="summary">交易涉及
    
    
                        <span v-for="(item,index) in eval.topPlateName" :key='index'>{{item}}、</span>
    
                        等 {{eval.countPlate}} 个板块，其中
                        <span v-if="eval.maxPlateProfit != null">
                            盈利最高板块为 {{eval.maxPlateProfit}}，
                            占总盈利的 <span style="font-weight: 600;">{{eval.ratioPlateInSumLoss}}%</span>；
                        </span>
                        <span v-if="eval.maxPlateLoss != null">
                            亏损最大板块为 {{eval.maxPlateLoss}}，
                            占总亏损的 <span style="font-weight: 600;">{{eval.ratioPlateInSumLoss}}%</span>
                        </span>
                        (以板块逐笔盈亏计算）
                    </div>
                </div>
                <h3 class="item102 title_font_color" style="font-size: 16pt;font-weight: 600;text-align: center;margin:0px">
                    &nbsp;<span class="part4">6</span>.<span class="small-tip4">8</span> 品种偏好</h3>
                <div class="panel panel-default">
                    <img v-show ='!show'  style="width: 737px;":src="main5_base64" alt="">
                    <div v-show ='show' class="panel-body main report" id="main5"
                        style="height: 280px;padding-top: 0px;padding-bottom: 0px">
                    </div>
                </div>
                <div style="margin: 10px 20px 10px 20px;font-size: 12px;"><label
                        style="color:#F36969 !important">*板块注释：</label>
                    <div>国债期货（二债、五债、十债），贵金属（沪金、沪银），有色金属（沪铜、沪铝、沪锌、沪铅、沪镍、沪锡），黑色金属（螺纹、铁矿、热卷、SS、线材、硅铁、锰硅），轻工（玻璃、纸浆、纤板、胶板），
                        煤炭（焦煤、焦炭、郑煤），原油（燃油、原油），化工（沥青、橡胶、NR、塑料、PTA、PVC、EG、郑醇、PP、EB、尿素、纯碱），谷物（玉米、豆一、淀粉、郑麦、普麦、粳米、早稻、粳稻、晚稻），
                        油脂油料（豆一、豆二、豆粕、豆油、菜籽、菜粕、郑油、棕榈），软商品（棉花、白糖、棉纱），农副（鸡蛋、苹果、红枣）。</div>
                </div>
    
                <div class="echarts_details">
                    <div class="summary">共交易 {{eval.productNum}} 个品种，其中
                        <span v-for="(item,index) in eval.plateRatioArray" :key='index'>
    
    
                            {{item.name}} 占比 <span style="font-weight: 600;">{{item.value}}%</span>
                        </span>
    
                        （以持仓保证金计算），持仓占用保证金最高的品种为 {{eval.plateRatioArray?eval.plateRatioArray[0].name:''}}，交易手数最多的品种为 ag
                    </div>
                </div>
            </div>
    
            <div class="A4">
    
    
    
    
    
    
                <div class="word-head">
                    <img src="../../../assets/images/report/logo-word.png" />
                    <span class="word-head-title"
                        style="color:#171718 !important;;margin-top: -35px;font-size: 14px;-webkit-transform: scale(0.8);">{{ res.reportStart  }}一{{ res.reportEnd  }}
                        <br />共计{{
                  eval.workDayCount
                }}交易日</span>
                    <div class="word-head-right"
                        style="top:4mm;text-align: right;padding-right: 7px;font-size: 12px;-webkit-transform: scale(0.8);">
    
                        {{user.phone}} -评估报告
                    </div>
                    <div class="word-footer" style="left:2px;width:200mm">
                        <span style="font-size: 12px;-webkit-transform: scale(0.8);">网址：www.jeesit.com</span>
                        <span class="pagenum"
                            style="color:#171718 !important;font-size:14px;-webkit-transform: scale(0.8);">1/2</span>
                        <span
                            style="text-align: right;font-size: 12px;-webkit-transform: scale(0.8);">导出人：{{user.name}}</span>
                    </div>
                </div>
                <h3 class="item103 title_font_color" style="font-size: 16pt;font-weight: 600;text-align: center;">
                    &nbsp;<span class="part4">6</span>.<span class="small-tip4">7</span> 品种逐日盈亏</h3>
                <div class="panel panel-default">
                    <img v-show ='!show'  style="width: 737px;":src="main7_base64" alt="">
                    <div v-show ='show' class="panel-body main report" id="main7">
                    </div>
    
                </div>
                <h3 class="item103 title_font_color" style="font-size: 16pt;font-weight: 600;text-align: center;">
                    &nbsp;<span class="part4">6</span>.<span class="small-tip4">7</span> 品种逐笔盈亏</h3>
                <div class="panel panel-default">
                    <img v-show ='!show'  style="width: 737px;":src="main6_base64" alt="">
                    <div v-show ='show' class="panel-body main report" id="main6">
                    </div>
                </div>
                <div class="echarts_details">
                    <div class="summary">共交易 {{eval.productNum}} 个品种，其中 {{eval.countProfit}} 个品种盈利， {{eval.countLoss}}个品种亏损，
                        品种盈亏比为 <span style="font-weight: 600;">{{eval.profitLossRatio}}</span> ，
                        <span v-if="eval.maxProductProfit != null">
                            盈利最高品种为 {{eval.maxProductProfit}}，
                            盈利 <span style="font-weight: 600;">{{eval.maxProductProfitMoney|money}}</span> 元，
                            占总盈利的 <span style="font-weight: 600;">{{eval.ratioInSumProfit}}%</span>，
                        </span>
                        亏损最大品种为{{eval.maxProductLoss}} ，
                        亏损 <span style="font-weight: 600;">{{eval.maxProductLossMoney|money}}</span> 元，
                        占总亏损的 <span style="font-weight: 600;">{{eval.ratioInSumLoss}}%</span>。（以逐笔盈亏计算） </div>
                </div>
            </div>
            <div class="A4">
    
    
    
    
    
    
                <div class="word-head">
                    <img src="../../../assets/images/report/logo-word.png" />
                    <span class="word-head-title"
                        style="color:#171718 !important;;margin-top: -35px;font-size: 14px;-webkit-transform: scale(0.8);">{{ res.reportStart  }}一{{ res.reportEnd  }}
                        <br />共计{{
                  eval.workDayCount
                }}交易日</span>
                    <div class="word-head-right"
                        style="top:4mm;text-align: right;padding-right: 7px;font-size: 12px;-webkit-transform: scale(0.8);">
    
                        {{user.phone}} -评估报告
                    </div>
                    <div class="word-footer" style="left:2px;width:200mm">
                        <span style="font-size: 12px;-webkit-transform: scale(0.8);">网址：www.jeesit.com</span>
                        <span class="pagenum"
                            style="color:#171718 !important;font-size:14px;-webkit-transform: scale(0.8);">1/2</span>
                        <span
                            style="text-align: right;font-size: 12px;-webkit-transform: scale(0.8);">导出人：{{user.name}}</span>
                    </div>
                </div>
                <h3 class="item13 title_font_color" style="font-size: 16pt;font-weight: 600;text-align: center;margin:0px;">
                    &nbsp;<span class="part4">6</span>.<span class="small-tip4">7</span> 品种持仓权益</h3>
                <div class="panel panel-default">
                    <img v-show ='!show'  style="width: 737px;":src="main13_base64" alt="">
                    <div v-show ='show' class="panel-body main report" id="main13_1"
                        style="height: 280px;padding-bottom: 0px;padding-top: 0px;">
                    </div>
                </div>
    
                <h3 class="item14 title_font_color" style="font-size: 16pt;font-weight: 600;text-align: center;margin:0px;">
                    &nbsp;<span class="part4">6</span>.<span class="small-tip4">7</span> 板块持仓权益</h3>
                <div class="panel panel-default">
                    <img v-show ='!show'  style="width: 737px;":src="main14_base64" alt="">
                    <div v-show ='show' class="panel-body main report" id="main14_1"
                        style="height: 280px;padding-bottom: 0px;padding-top: 0px;">
                    </div>
                </div>
    
                <h3 class="item15 title_font_color" style="font-size: 16pt;font-weight: 600;text-align: center;margin:0px;">
                    &nbsp;<span class="part4">6</span>.<span class="small-tip4">7</span> 持仓K线</h3>
                <div class="panel panel-default">
                    <img v-show ='!show'  style="width: 737px;":src="main15_base64" alt="">
                    <div v-show ='show' class="panel-body main report" id="main15_1"
                        style="height: 280px;padding-bottom: 0px;padding-top: 0px;">
                    </div>
                </div>
            </div>
    
            <div class="A4">
    
    
    
    
    
    
                <div class="word-head">
                    <img src="../../../assets/images/report/logo-word.png" />
                    <span class="word-head-title"
                        style="color:#171718 !important;;margin-top: -35px;font-size: 14px;-webkit-transform: scale(0.8);">{{ res.reportStart  }}一{{ res.reportEnd  }}
                        <br />共计{{
                  eval.workDayCount
                }}交易日</span>
                    <div class="word-head-right"
                        style="top:4mm;text-align: right;padding-right: 7px;font-size: 12px;-webkit-transform: scale(0.8);">
    
                        {{user.phone}} -评估报告
                    </div>
                    <div class="word-footer" style="left:2px;width:200mm">
                        <span style="font-size: 12px;-webkit-transform: scale(0.8);">网址：www.jeesit.com</span>
                        <span class="pagenum"
                            style="color:#171718 !important;font-size:14px;-webkit-transform: scale(0.8);">1/2</span>
                        <span
                            style="text-align: right;font-size: 12px;-webkit-transform: scale(0.8);">导出人：{{user.name}}</span>
                    </div>
                </div>
                <h3 class="item17 title_font_color" style="font-size: 16pt;font-weight: 600;text-align: center;">&nbsp;<span
                        class="part4">8</span>.<span class="small-tip4">7</span> 多空持仓保证金</h3>
                <div class="panel panel-default">
                    <img v-show ='!show'  style="width: 737px;":src="main17_base64" alt="">
                    <div v-show ='show' class="panel-body main report" id="main17_1">
                    </div>
                </div>
                <h3 class="item20 title_font_color" style="font-size: 16pt;font-weight: 600;text-align: center;">&nbsp;<span
                        class="part4">6</span>.<span class="small-tip4">7</span> 板块逐月成交保证金</h3>
                <div class="panel panel-default">
                    <img v-show ='!show'  style="width: 737px;":src="main20_base64" alt="">
                    <div v-show ='show' class="panel-body main report" id="main20_1">
                    </div>
                </div>
            </div>
    
    
            <div class="A4">
    
    
    
    
    
    
                <div class="word-head">
                    <img src="../../../assets/images/report/logo-word.png" />
                    <span class="word-head-title"
                        style="color:#171718 !important;;margin-top: -35px;font-size: 14px;-webkit-transform: scale(0.8);">{{ res.reportStart  }}一{{ res.reportEnd  }}
                        <br />共计{{
                  eval.workDayCount
                }}交易日</span>
                    <div class="word-head-right"
                        style="top:4mm;text-align: right;padding-right: 7px;font-size: 12px;-webkit-transform: scale(0.8);">
    
                        {{user.phone}} -评估报告
                    </div>
                    <div class="word-footer" style="left:2px;width:200mm">
                        <span style="font-size: 12px;-webkit-transform: scale(0.8);">网址：www.jeesit.com</span>
                        <span class="pagenum"
                            style="color:#171718 !important;font-size:14px;-webkit-transform: scale(0.8);">1/2</span>
                        <span
                            style="text-align: right;font-size: 12px;-webkit-transform: scale(0.8);">导出人：{{user.name}}</span>
                    </div>
                </div>
                <h2 class="item104 title_font_color" style="font-size: 22pt;text-align: center;font-weight: 600;">第<span
                        class="titlenum part5">5</span>部分 周期分析</h2>
                <div class="block_msg" style="height: 109px;font-size: 12px;margin: 0px 20px 20px 20px;display: flex;justify-content: space-around;align-items: center;border:1px #E2E4E8 solid;border-radius: 5px !important;text-align: center;">
                    <li class="block_i">
                        <span style="color: #468bf1 !important">持仓周期最长品种</span>
                        <p style="margin-top: 15px;font-size: 22px;">{{proChoose.maxDaysProduct}}</p>
                    </li>
                    <li class="block_i">
                        <span style="color: #468bf1 !important">持仓周期最长板块</span>
                        <p style="margin-top: 15px;font-size: 22px;">{{proChoose.maxDaysPlate}}</p>
                    </li>
                    <li class="block_i">
                        <span style="color: #f14d4d !important">盈利最高周期</span>
                        <p style="margin-top: 15px;font-size: 22px;">{{cycleEval.gainInter==0?"日内":(cycleEval.gainInter==1?"短线":(cycleEval.gainInter==2?"中线":(cycleEval.gainInter==3?"长线":"暂无")))}}
                        </p>
                    </li>
                    <li class="block_i">
                        <span style="color: #32b977 !important">亏损最多周期</span>
                        <p style="margin-top: 15px;font-size: 22px;">{{cycleEval.lossInter==0?"日内":(cycleEval.lossInter==1?"短线":(cycleEval.lossInter==2?"中线":(cycleEval.lossInter==3?"长线":"暂无")))}}
                        </p>
                    </li>
                    <li class="block_i">
                        <span style="color: #f14d4d !important">胜率最高</span>
                        <p style="margin-top: 15px;font-size: 22px;">{{cycleEval.highestGainRate==0?"日内":(cycleEval.highestGainRate==1?"短线":(cycleEval.highestGainRate==2?"中线":(cycleEval.highestGainRate==3?"长线":"暂无")))}}
                        </p>
                    </li>
                    <li class="block_i">
                        <span style="color: #32b977 !important">胜率最低</span>
                        <p style="margin-top: 15px;font-size: 22px;">{{cycleEval.lowestGainRate==0?"日内":(cycleEval.lowestGainRate==1?"短线":(cycleEval.lowestGainRate==2?"中线":(cycleEval.lowestGainRate==3?"长线":"暂无")))}}
                        </p>
                    </li>
                </div>
                <h3 class="item105 title_font_color" style="font-size: 16pt;font-weight: 600;text-align: center;">
                    &nbsp;<span class="part5">5</span>.<span class="small-tip5">5</span> 品种周期</h3>
                <div class="table tableRels">
                    <table border="1" class="table table-bordered text-right" style="margin: 0px 20px 20px 20px;width: auto">
                        <thead class="flip-content">
                            <tr>
                                <th style="text-align: center;width: 10%">品种</th>
                                <th style="width: 15%;">总盈亏</th>
                                <th style="width: 12%;">总手数</th>
                                <th style="width: 20%;">平均持仓周期（天）</th>
                                <th style="width: 20%;">最大持仓周期（天）</th>
                                <th style="width: 20%;">最大持仓周期</th>
                            </tr>
                        </thead>
                        <tbody>
    
    
    
    
                            
                            <tr v-if='index < proChoose.productDays.length&&index<15' v-for="(item,index) in proChoose.productDays" :key='index'>
                                <td style="text-align: center">{{item.name}}</td>
                                <td style="color:#F14D4D !important">{{item.closePorfit}}</td>
                                <td>{{item.volume}}</td>
                                <td>{{item.avgDays}}</td>
                                <td>{{item.maxDays}}</td>
                                <td>{{item.openTradingDay-item.closeTradingDay}}</td>
                            </tr>


    
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="A4" v-show="proChoose.productDays?proChoose.productDays.length>15:false">

                <div class="word-head">
                    <img src="../../../assets/images/report/logo-word.png" />
                    <span class="word-head-title"
                        style="color:#171718 !important;;margin-top: -35px;font-size: 14px;-webkit-transform: scale(0.8);">{{ res.reportStart  }}一{{ res.reportEnd  }}
                        <br />共计{{
                  eval.workDayCount
                }}交易日</span>
                    <div class="word-head-right"
                        style="top:4mm;text-align: right;padding-right: 7px;font-size: 12px;-webkit-transform: scale(0.8);">
    
                        {{user.phone}} -评估报告
                    </div>
                    <div class="word-footer" style="left:2px;width:200mm">
                        <span style="font-size: 12px;-webkit-transform: scale(0.8);">网址：www.jeesit.com</span>
                        <span class="pagenum"
                            style="color:#171718 !important;font-size:14px;-webkit-transform: scale(0.8);">1/2</span>
                        <span
                            style="text-align: right;font-size: 12px;-webkit-transform: scale(0.8);">导出人：{{user.name}}</span>
                    </div>
                </div>

                <div class="table tableRels">
                    <table border="1" class="table table-bordered text-right" style="margin: 0px 20px 20px 20px;width: auto">
                        <thead class="flip-content">
                            <tr>
                                <th style="text-align: center;width: 10%">品种</th>
                                <th style="width: 15%;">总盈亏</th>
                                <th style="width: 12%;">总手数</th>
                                <th style="width: 20%;">平均持仓周期（天）</th>
                                <th style="width: 20%;">最大持仓周期（天）</th>
                                <th style="width: 20%;">最大持仓周期</th>
                            </tr>
                        </thead>
                        <tbody>
    
    
    
    
                            
                            <tr v-if='index < proChoose.productDays.length&&index>15&&index<35' v-for="(item,index) in proChoose.productDays" :key='index'>
                                <td style="text-align: center">{{item.name}}</td>
                                <td style="color:#F14D4D !important">{{item.closePorfit}}</td>
                                <td>{{item.volume}}</td>
                                <td>{{item.avgDays}}</td>
                                <td>{{item.maxDays}}</td>
                                <td>{{item.openTradingDay-item.closeTradingDay}}</td>
                            </tr>


    
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="A4" v-show="proChoose.productDays?proChoose.productDays.length>35:false">
    
    
    
    
    
    
                <div class="word-head">
                    <img src="../../../assets/images/report/logo-word.png" />
                    <span class="word-head-title"
                        style="color:#171718 !important;;margin-top: -35px;font-size: 14px;-webkit-transform: scale(0.8);">{{ res.reportStart  }}一{{ res.reportEnd  }}
                        <br />共计{{
                  eval.workDayCount
                }}交易日</span>
                    <div class="word-head-right"
                        style="top:4mm;text-align: right;padding-right: 7px;font-size: 12px;-webkit-transform: scale(0.8);">
    
                        {{user.phone}} -评估报告
                    </div>
                    <div class="word-footer" style="left:2px;width:200mm">
                        <span style="font-size: 12px;-webkit-transform: scale(0.8);">网址：www.jeesit.com</span>
                        <span class="pagenum"
                            style="color:#171718 !important;font-size:14px;-webkit-transform: scale(0.8);">1/2</span>
                        <span
                            style="text-align: right;font-size: 12px;-webkit-transform: scale(0.8);">导出人：{{user.name}}</span>
                    </div>
                </div>
              
                
               
                <div class="table tableRels">
                    <table border="1" class="table table-bordered text-right" style="margin: 0px 20px 20px 20px;width: auto">
                        <thead class="flip-content">
                            <tr>
                                <th style="text-align: center;width: 10%">品种</th>
                                <th style="width: 15%;">总盈亏</th>
                                <th style="width: 12%;">总手数</th>
                                <th style="width: 20%;">平均持仓周期（天）</th>
                                <th style="width: 20%;">最大持仓周期（天）</th>
                                <th style="width: 20%;">最大持仓周期</th>
                            </tr>
                        </thead>
                        <tbody>
    
    
    
    
                            
                            <tr v-if='index < proChoose.productDays.length&&index>35&&index<55' v-for="(item,index) in proChoose.productDays" :key='index'>
                                <td style="text-align: center">{{item.name}}</td>
                                <td style="color:#F14D4D !important">{{item.closePorfit}}</td>
                                <td>{{item.volume}}</td>
                                <td>{{item.avgDays}}</td>
                                <td>{{item.maxDays}}</td>
                                <td>{{item.openTradingDay-item.closeTradingDay}}</td>
                            </tr>


    
                        </tbody>
                    </table>
                </div>
            </div>
    
            <div class="A4 table tableRels">
    
    
    
    
    
    
                <div class="word-head ">
                    <img src="../../../assets/images/report/logo-word.png" />
                    <span class="word-head-title"
                        style="color:#171718 !important;;margin-top: -35px;font-size: 14px;-webkit-transform: scale(0.8);">{{ res.reportStart  }}一{{ res.reportEnd  }}
                        <br />共计{{
                  eval.workDayCount
                }}交易日</span>
                    <div class="word-head-right"
                        style="top:4mm;text-align: right;padding-right: 7px;font-size: 12px;-webkit-transform: scale(0.8);">
    
                        {{user.phone}} -评估报告
                    </div>
                    <div class="word-footer" style="left:2px;width:200mm">
                        <span style="font-size: 12px;-webkit-transform: scale(0.8);">网址：www.jeesit.com</span>
                        <span class="pagenum"
                            style="color:#171718 !important;font-size:14px;-webkit-transform: scale(0.8);">1/2</span>
                        <span
                            style="text-align: right;font-size: 12px;-webkit-transform: scale(0.8);">导出人：{{user.name}}</span>
                    </div>
                </div>
                <h3 class="item106 title_font_color" style="font-size: 16pt;font-weight: 600;text-align: center;">
                    &nbsp;<span class="part5">5</span>.<span class="small-tip5">4</span> 板块周期</h3>
                <table border="1" class="table table-bordered  text-right">
                    <thead class="flip-content">
                        <tr>
                            <th style="text-align: center">板块</th>
                            <th>总盈亏</th>
                            <th>总手数</th>
                            <th>平均持仓周期（天）</th>
                            <th>最大持仓周期（天）</th>
                            <th>最大持仓周期</th>
                        </tr>
                    </thead>
                    <tbody>
    
                        <tr v-for="(item,index) in proChoose.plateDays" :key=index>
                            <td style="text-align: center">{{item.name}}</td>
                            <td :style="{color:item.closePorfit>0?'red !important':'green !important'}">
                                {{item.closePorfit|money}}</td>
                            <td>{{item.volume}}</td>
                            <td>{{item.avgDays}}</td>
                            <td>{{item.maxDays}}</td>
                            <td>{{item.openTradingDay}}-{{item.closeTradingDay}}</td>
                        </tr>
    
                    </tbody>
                </table>


                
            </div>

            
    
            <div class="A4">
    
    
    
    
    
    
                <div class="word-head">
                    <img src="../../../assets/images/report/logo-word.png" />
                    <span class="word-head-title"
                        style="color:#171718 !important;;margin-top: -35px;font-size: 14px;-webkit-transform: scale(0.8);">{{ res.reportStart  }}一{{ res.reportEnd  }}
                        <br />共计{{
                  eval.workDayCount
                }}交易日</span>
                    <div class="word-head-right"
                        style="top:4mm;text-align: right;padding-right: 7px;font-size: 12px;-webkit-transform: scale(0.8);">
    
                        {{user.phone}} -评估报告
                    </div>
                    <div class="word-footer" style="left:2px;width:200mm">
                        <span style="font-size: 12px;-webkit-transform: scale(0.8);">网址：www.jeesit.com</span>
                        <span class="pagenum"
                            style="color:#171718 !important;font-size:14px;-webkit-transform: scale(0.8);">1/2</span>
                        <span
                            style="text-align: right;font-size: 12px;-webkit-transform: scale(0.8);">导出人：{{user.name}}</span>
                    </div>
                </div>
    
                <h3 class="item21 title_font_color" style="font-size: 16pt;font-weight: 600;text-align: center;">&nbsp;<span
                        class="part5">5</span>.<span class="small-tip5">7</span> 周期盈亏</h3>
                <div class="panel panel-default">
                    <img v-show ='!show'  style="width: 737px;":src="main21_base64" alt="">
                    <div v-show ='show' class="panel-body main report" id="main21_1">
                    </div>
                </div>
    
                <h3 class="item22 title_font_color" style="font-size: 16pt;font-weight: 600;text-align: center;">&nbsp;<span
                        class="part5">5</span>.<span class="small-tip5">7</span> 周期胜算率</h3>
                <div class="panel panel-default">
                    <img v-show ='!show'  style="width: 737px;":src="main22_base64" alt="">
                    <div v-show ='show' class="panel-body main report" id="main22_1">
                    </div>
                </div>
            </div>
    
    
            <div class="A4 table tableRels">
    
    
    
    
    
    
                <div class="word-head" >
                    <img src="../../../assets/images/report/logo-word.png" />
                    <span class="word-head-title"
                        style="color:#171718 !important;;margin-top: -35px;font-size: 14px;-webkit-transform: scale(0.8);">2021年06月21日至2021年06月28日
                        <br>共计6交易日</span>
                    <div class="word-head-right"
                        style="top:4mm;text-align: right;padding-right: 7px;font-size: 12px;-webkit-transform: scale(0.8);">
    
                        {{user.phone}} -评估报告
                    </div>
                    <div class="word-footer" style="left:2px;width:200mm">
                        <span style="font-size: 12px;-webkit-transform: scale(0.8);">网址：www.jeesit.com</span>
                        <span class="pagenum"
                            style="color:#171718 !important;font-size:14px;-webkit-transform: scale(0.8);">1/2</span>
                        <span
                            style="text-align: right;font-size: 12px;-webkit-transform: scale(0.8);">导出人：{{user.name}}</span>
                    </div>
                </div>
                <h2 class="item1 title_font_color" style="font-size: 22pt;text-align: center;font-weight: 600;">第<span
                        class="titlenum">六</span>部分 每日评估</h2>
                <table border="1" class="table table-bordered text-right ">
                    <thead class="flip-content">
                        <tr>
                            <th style="text-align: center">交易日</th>
                            <th>净值</th>
                            <th>期末权益</th>
                            <th>总盈亏</th>
                            <th>当日盈亏</th>
                            <th>累计手续费</th>
                            <th>手续费</th>
                            <th>持仓</th>
                        </tr>
                    </thead>
                    <tbody>
    
    
    
                        <tr v-if='index<20' v-for = "(item,index) in eval.datas" :key='index'>
                            <td style="text-align: center">{{item.tradingDay}}</td>
                            <td :style="{color:item.netValue>1?'#F14D4D !important':'#32B977 !important'}">{{item.netValue|num2}}</td>
                            <td>{{item.balance|num1}}</td>
                            <td :style="{color:item.sumProfit>0?'#F14D4D !important':'#32B977 !important'}">{{item.sumProfit|num1}}</td>
                            <td :style="{color:item.positionProfit+item.closeProfit>0?'#32B977 !important':'#32B977 !important'}">{{item.positionProfit+item.closeProfit|num1}}</td>
                            <td>{{item.sumCommosion|num1}}</td>
                            <td>{{item.commission|num1}}</td>
                            <td>{{item.position|num}}</td>
                        </tr>
    
                    </tbody>
                </table>
            </div>

            <div class="A4 table tableRels" v-if = "eval.datas?eval.datas.length>20+i*20:false" v-for="(e,i) in eval.datas" :key='i'>
    

                <div class="word-head" >
                    <img src="../../../assets/images/report/logo-word.png" />
                    <span class="word-head-title"
                        style="color:#171718 !important;;margin-top: -35px;font-size: 14px;-webkit-transform: scale(0.8);">2021年06月21日至2021年06月28日
                        <br>共计6交易日</span>
                    <div class="word-head-right"
                        style="top:4mm;text-align: right;padding-right: 7px;font-size: 12px;-webkit-transform: scale(0.8);">
    
                        {{user.phone}} -评估报告
                    </div>
                    <div class="word-footer" style="left:2px;width:200mm">
                        <span style="font-size: 12px;-webkit-transform: scale(0.8);">网址：www.jeesit.com</span>
                        <span class="pagenum"
                            style="color:#171718 !important;font-size:14px;-webkit-transform: scale(0.8);">1/2</span>
                        <span
                            style="text-align: right;font-size: 12px;-webkit-transform: scale(0.8);">导出人：{{user.name}}</span>
                    </div>
                </div>
               
                <table border="1" class="table table-bordered text-right ">
                    <thead class="flip-content">
                        <tr>
                            <th style="text-align: center">交易日</th>
                            <th>净值</th>
                            <th>期末权益</th>
                            <th>总盈亏</th>
                            <th>当日盈亏</th>
                            <th>累计手续费</th>
                            <th>手续费</th>
                            <th>持仓</th>
                        </tr>
                    </thead>
                    <tbody>
    
    
    
                        <tr v-if='index>20*i&&index<20+20*i' v-for = "(item,index) in eval.datas" :key='index'>
                            <td style="text-align: center">{{item.tradingDay}}</td>
                            <td :style="{color:item.netValue>1?'#F14D4D !important':'#32B977 !important'}">{{item.netValue|num2}}</td>
                            <td>{{item.balance|num1}}</td>
                            <td :style="{color:item.sumProfit>0?'#F14D4D !important':'#32B977 !important'}">{{item.sumProfit|num1}}</td>
                            <td :style="{color:item.positionProfit+item.closeProfit>0?'#32B977 !important':'#32B977 !important'}">{{item.positionProfit+item.closeProfit|num1}}</td>
                            <td>{{item.sumCommosion|num1}}</td>
                            <td>{{item.commission|num1}}</td>
                            <td>{{item.position|num}}</td>
                        </tr>
    
                    </tbody>
                </table>
            </div>
<!-- 
            <div class="A4" v-if='eval.datas.length>22' >
                <table class="table table-bordered text-right ">
                    <thead class="flip-content">
                        <tr>
                            <th style="text-align: center">交易日</th>
                            <th>净值</th>
                            <th>期末权益</th>
                            <th>总盈亏</th>
                            <th>当日盈亏</th>
                            <th>累计手续费</th>
                            <th>手续费</th>
                            <th>持仓</th>
                        </tr>
                    </thead>
                    <tbody>
    
    
    
                        <tr v-if='index>22&&index<47' v-for = "(item,index) in eval.datas" :key='index'>
                            <td style="text-align: center">{{item.tradingDay}}</td>
                            <td :style="{color:item.netValue>1?'#F14D4D !important':'#32B977 !important'}">{{item.netValue|num2}}</td>
                            <td>{{item.balance|num1}}</td>
                            <td :style="{color:item.sumProfit>0?'#F14D4D !important':'#32B977 !important'}">{{item.sumProfit|num1}}</td>
                            <td :style="{color:item.positionProfit+item.closeProfit>0?'#32B977 !important':'#32B977 !important'}">{{item.positionProfit+item.closeProfit|num1}}</td>
                            <td>{{item.sumCommosion|num1}}</td>
                            <td>{{item.commission|num1}}</td>
                            <td>{{item.position|num}}</td>
                        </tr>
    
                    </tbody>
                </table>
            </div> -->


        </div>


    </div>
    </div>
</template>
<script>
    import './style.css';
    const echarts = require('echarts');
    // import vueEasyPrint from "vue-easy-printer";
    import $ from 'jQuery';
    export default {
        // components:{vueEasyPrint},
        data() {
            return {
                main1_base64:'',
                main2_base64:'',
                main3_base64:'',
                main4_base64:'',
                main5_base64:'',
                main6_base64:'',
                main7_base64:'',
                main8_base64:'',
                main9_base64:'',
                main10_base64:'',
                main11_base64:'',
                main12_base64:'',
                main13_base64:'',
                main14_base64:'',
                main15_base64:'',
                main16_base64:'',
                main17_base64:'',
                main18_base64:'',
                main19_base64:'',
                main20_base64:'',
                main21_base64:'',
                main22_base64:'',
                
                WS:document.body.clientWidth,
                settingArray: [],
                res: '',
                eval: '',
                usr: '',
                show: true,
                pro: '',
                proChoose: '',
                cycleEval: '',
                user: '',
                bg: "url(" + require("@/assets/images/report/printbg1.png") + ") !important",
                bg2: "url(" + require("@/assets/images/report/printbg2.png") + ") !important",
                bg3: "url(" + require("@/assets/images/report/printbg3.png") + ") !important",
                htmlTitle: '页面导出PDF文件名'
            };
        },
        filters: {

            dates: function (date) {
                if (date) {
                    return (
                        date
                            .substr(0, 10)
                            .replace('/', '年')
                            .replace('/', '月') + '日'
                    );
                }
            },
            num: function (n) {
                if (n) {
                    return (Math.round(n * 10000) / 100).toFixed(2) + '%';
                } else {
                    return '0.00%';
                }
            },
            num1: function (n) {
                if (n) {
                    return (Math.round(n * 100) / 100).toFixed(2)
                } else {
                    return '0'
                }
            },
            num2: function (n) {
                if (n) {
                    return (Math.round(n * 10000) / 10000).toFixed(4)
                } else {
                    return '0'
                }
            },
            money: function (n) {
                if (n) {
                    return n.toFixed(2)
                } else {
                    return '0.00'
                }
            }
        },
        created() {

        },
        mounted() {
            let s = this.$route.query.startTime
            let e = this.$route.query.entTime
            this.$axios
                .post('/cloud/ctp_user/eval', {
                    //账户分析
                    apiToken: this.$store.state.usermsg.apiToken,
                    userId: this.$route.query.id,
                    customerId: this.$route.query.customerId
                    // startTime:s.substr(0,4)+'/'+s.substr(4,2)+'/'+s.substr(6,2),	
                    // entTime:e.substr(0,4)+'/'+e.substr(4,2)+'/'+e.substr(6,2),
                })
                .then((res) => {

                    if (res.data.code == 200) {
                        this.res = res.data.data;
                        this.eval = res.data.data.eval
                        this.usr = res.data.data.usr
                        this.pro = res.data.data.pro
                        this.cycleEval = res.data.data.cycleEval
                        this.proChoose = res.data.data.proChoose
                        this.user = res.data.data.user
                        this.settingArray = res.data.data.settingArray
                          console.log(this.res)
                        var that = this
                        setTimeout(function () {

                            that.option();
                        }, 0)
                    }
                });

            var pageCount = $('.pagenum').length;
            var num = 1;
            // console.log($('.pagenum'))
            $('.pagenum').each(function () {
                $(this).text(num + '/' + pageCount);
                num++;
            });
            var jj = 1;
            $('.gmu').each(function () {
                $(this).text(jj);
                jj++;
            });
            var jj2 = 1;
            $('.gmu2').each(function () {
                $(this).text(jj2);
                jj2++;
            });
            var jj3 = 1;
            $('.gmu3').each(function () {
                $(this).text(jj3);
                jj3++;
            });
            var jj5 = 1;
            $('.gmu5').each(function () {
                $(this).text(jj5);
                jj5++;
            });
            $('.pdfh').show();
            $('.mulu').each(function () {
                var dataIndex = $(this).attr('data');
                var mulu = $('.item' + dataIndex)
                    .closest('.A4')
                    .find('.pagenum')
                    .text()
                    .split('/')[0];
                $(this).text(mulu);
            });
            //----
            var small = 1;
            $('.small-tip').each(function () {
                // var size = $(".small-tip").length;
                $(this).text(small);
                small++;
            });
            var small3 = 1;
            $('.small-tip3').each(function () {
                // var size = $(".small-tip").length;
                $(this).text(small3);
                small3++;
            });
            var small4 = 1;
            $('.small-tip4').each(function () {
                // var size = $(".small-tip").length;
                $(this).text(small4);
                small4++;
            });
            var small5 = 1;
            $('.small-tip5').each(function () {
                // var size = $(".small-tip").length;
                $(this).text(small5);
                small5++;
            });
            //目录第几部分处理
            var catalognum = 1;
            // console.log($('.catalognum'))
            $('.catalognum').each(function () {
                if (catalognum == 1) {
                    $(this).text('一');
                    $(this)
                        .parent()
                        .parent()
                        .find('.catalognum_title')
                        .each(function () {
                            $(this).text(catalognum);
                        });
                } else if (catalognum == 2) {
                    $(this).text('二');
                    $(this)
                        .parent()
                        .parent()
                        .find('.catalognum_title')
                        .each(function () {
                            $(this).text(catalognum);
                        });
                } else if (catalognum == 3) {
                    $(this).text('三');
                    $(this)
                        .parent()
                        .parent()
                        .find('.catalognum_title')
                        .each(function () {
                            $(this).text(catalognum);
                        });
                } else if (catalognum == 4) {
                    $(this).text('四');
                    $(this)
                        .parent()
                        .parent()
                        .find('.catalognum_title')
                        .each(function () {
                            $(this).text(catalognum);
                        });
                } else if (catalognum == 5) {
                    $(this).text('五');
                }
                catalognum++;
                // console.log(catalognum,1231323121)
            });
            //内容部分第几个 处理
            var titlenum = 1;
            $('.titlenum').each(function () {
                if (titlenum == 1) {
                    $(this).text('一');
                    $(this).css('color', '#2973E2 !important');
                } else if (titlenum == 2) {
                    $(this).text('二');
                    $(this).css('color', '#2973E2 !important');
                } else if (titlenum == 3) {
                    $(this).text('三');
                    $(this).css('color', '#2973E2 !important');
                } else if (titlenum == 4) {
                    $(this).text('四');
                    $(this).css('color', '#2973E2 !important');
                } else if (titlenum == 5) {
                    $(this).text('五');
                    $(this).css('color', '#2973E2 !important');
                }
                titlenum++;
            });

            var part2 = 1;
            var flag2 = 0;
            var that = this;
            $('.part2').each(function () {
                if (part2 == 1) {
                    flag2 = that.getNum($(this).text());
                } else {
                    $(this).text(flag2);
                    $(this).css('color', '#2973E2 !important');
                }
                part2++;
            });

            var part3 = 1;
            var flag3 = 0;
            $('.part3').each(function () {
                if (part3 == 1) {
                    flag3 = that.getNum($(this).text());
                } else {
                    $(this).text(flag3);
                    $(this).css('color', '#2973E2 !important');
                }
                part3++;
            });

            var part4 = 1;
            var flag4 = 0;
            $('.part4').each(function () {
                if (part4 == 1) {
                    flag4 = that.getNum($(this).text());
                } else {
                    $(this).text(flag4);
                    $(this).css('color', '#2973E2 !important');
                }
                part4++;
            });

            var part5 = 1;
            var flag5 = 0;
            $('.part5').each(function () {
                if (part5 == 1) {
                    flag5 = that.getNum($(this).text());
                } else {
                    $(this).text(flag5);
                    $(this).css('color', '#2973E2 !important');
                }
                part5++;
            });


        },
        methods: {
            getNum(i) {
                if (i == '一') {
                    return 1;
                } else if (i == '二') {
                    return 2;
                } else if (i == '三') {
                    return 3;
                } else if (i == '四') {
                    return 4;
                }
            },
            drawcharts(chartdata, id) {
                // 可以设置主题： "dark"、 "light"

                let mychart = echarts.init(document.getElementById(id));


                mychart.setOption(chartdata);



                let chartBase64 = mychart.getDataURL();
                return chartBase64;
            },
            savePdf() {
                const loading = this.$loading({
          lock: true,
          text: '正在下载',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        
                var that = this
                this.show = false
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                setTimeout(()=>{
                    this.$PDFSave(this.$refs.exportPdf_, "我的文件");

                 
                },1000)
                setTimeout(() => {
          loading.close();
          that.show = true
       
        }, 3000);
                
                // this.show = true
            },
            printPdf(){
                var that = this
                this.show = false
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                // setTimeout(()=>{

                    this.$easyPrint('exportPdf',"我的文件",'portrait');
                // },1000)
   },
            splitData(rawData) {
                var categoryData = [];
                var values = [];
                var volumes = [];
                for (var i = 0; i < rawData.length; i++) {
                    categoryData.push(rawData[i].splice(0, 1)[0]);
                    values.push(rawData[i]);
                    volumes.push([
                        i,
                        rawData[i][4],
                        rawData[i][0] > rawData[i][1] ? 1 : -1,
                    ]);
                }
                return {
                    categoryData: categoryData,
                    values: values,
                    volumes: volumes,
                };
            },
            calculateMA(dayCount, data) {
                var result = [];
                for (var i = 0, len = data.values.length; i < data.values.length; i++) {
                    if (i < dayCount) {
                        result.push('-');
                        continue;
                    }
                    if (data.categoryData.length <= dayCount) {
                        return result;
                    }
                    var sum = 0;
                    for (var j = 0; j < dayCount; j++) {
                        sum += data.values[i - j][1];
                    }
                    result.push(+(sum / dayCount).toFixed(3));
                }
                return result;
            },
            splitMonthData(monthPorfitArray) {
                var data = new Array();
                for (var i = 0; i < monthPorfitArray.length; i++) {
                    var monthPorfit = monthPorfitArray[i];
                    if (monthPorfit.flag) {
                        var position = 'top';
                        if (monthPorfit.value < 0) {
                            position = 'bottom';
                        }
                        var json = {
                            value: monthPorfit.value,
                            label: {
                                normal: {
                                    // formatter: formatter,
                                    show: true,
                                    position: position,
                                },
                            },
                        };
                        data.push(json);
                    } else {
                        data.push(monthPorfit.value);
                    }
                }
                return data;
            },
            option() {
                var upColor = '#ffffff';
                var upBorderColor = '#ec0000';
                var downColor = '#00da3c';
                // var userNetData =  this.splitData(this.res.userNetArray)
                var userNetData15 = this.splitData(this.proChoose.positonKArray)
               
                var graphic = {type:'image',
        style:{z: -10,
        position:0,
        height: 450,
        // image: this.image,    
    }
       
    }


                var option1 = {
                    graphic: graphic,
                    animation: false,
                    tooltip: {
                        trigger: 'axis',
                        formatter: function (params) {
                            var res = params[0].name + "<br/>";
                            res += getColor(params[0]) + params[0].seriesName + "：" + params[0].value + "<br/>";
                            res += getColor(params[1]) + params[1].seriesName + "：" + params[1].value.toFixed(4) + "<br/>";
                            res += getColor(params[2]) + params[2].seriesName + "：" + params[2].value + "%<br/>";
                            return res;
                        },
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        }
                    },
                    grid: {
                        left: 40,
                        right: 40,
                        bottom: 30,
                        containLabel: false
                    },
                    legend: {
                        data: ['累计净值', '持仓'],
                        right: 40
                    },
                    xAxis: [
                        {
                            type: 'category',
                            axisPointer: {
                                type: 'shadow'
                            },
                            data: this.res.profitNetArray
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            name: '净值',
                            scale: true,
                            // min: 0,
                            // max: 25,
                            splitNumber: 6,
                            position: 'right'
                            // axisLabel: {
                            //     formatter: '{value} °C'
                            // }
                        },
                        {
                            type: 'value',
                            name: '持仓',
                            scale: true,
                            // min: 0,
                            max: 100,
                            interval: 10,
                            axisLabel: {
                                formatter: '{value} %'
                            },
                            position: 'left',
                            splitLine: { show: false }
                        }
                    ],
                    color: ['red', '#ad0404', '#5599FF'],
                    series: [
                        
                        {
                            name: '累计净值',
                            type: 'line',
                            symbol: 'none',
                            lineStyle: {
                                normal: {
                                    width: 3,
                                    shadowColor: 'rgba(0,0,0,0.4)',
                                    shadowBlur: 10,
                                    shadowOffsetY: 10
                                }
                            },
                            data: this.eval.netValueArray
                        },
                        {
                            name: '持仓',
                            type: 'bar',
                            symbol: 'none',
                            yAxisIndex: 1,
                            itemStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(
                                        0, 0, 0, 1,
                                        [
                                            { offset: 0, color: '#188df0' },
                                            { offset: 0.5, color: '#188df0' },
                                            { offset: 1, color: '#83bff6' }
                                        ]
                                    )
                                }
                            },
                            data: this.eval.positionArray
                        },
                    ]
                };
                var option2 = {
                    // title: {
                    //     text: '净值与回撤',
                    //     left:'left'
                    // },
                    animation: false,
                    graphic: graphic,
                    tooltip: {
                        trigger: 'axis',
                        formatter: function (params) {
                            var res = params[0].name + "<br/>";
                            var netvalue = '';
                            var lossValue = '';
                            if (params[0].seriesName == '净值') {
                                netvalue = params[0].value != '-' ? params[0].value : params[1].value;
                                lossValue = params[2].value;
                            } else {
                                netvalue = params[1].value != '-' ? params[1].value : params[2].value;
                                lossValue = params[0].value;
                            }
                            res += "净值 :" + netvalue + "<br/>";
                            res += "回撤 :" + lossValue + "%<br/>";
                            return res;
                        },
                    },
                    grid: [
                        {
                            left: 40,
                            right: 40,
                            bottom: '40%',
                            height: '45%'
                        },
                        {
                            left: 40,
                            right: 40,
                            bottom: '7%',
                            height: '30%'
                        }
                    ],
                    legend: {
                        data: ['净值', '历史回撤'],
                        right: 40
                    },
                    axisPointer: {
                        link: [{
                            xAxisIndex: [0, 1]
                        }]
                    },
                    xAxis: [
                        {
                            type: 'category',
                            boundaryGap: false,
                            axisLabel: { show: false },
                            axisLabel: { show: false },
                            axisTick: { show: false },
                            axisLine: { onZero: false },
                            data: this.eval.dateArray
                        },
                        {
                            type: 'category',
                            gridIndex: 1,
                            boundaryGap: false,
                            axisLine: { onZero: false },
                            data: this.eval.dateArray
                        }
                    ],
                    yAxis: [
                        {
                            name: '',
                            scale: true,
                            splitNumber: 3,
                            axisLabel: {
                            },
                            type: 'value',
                            position: 'right'
                        },
                        {
                            name: '',
                            gridIndex: 1,
                            splitNumber: 2,
                            boundaryGap: ['20%', '0%'],
                            type: 'value',
                            // max : 1,

                            axisLabel: {
                                formatter: '{value} %'
                            },
                            position: 'right'
                        }
                    ],
                    // color:['red','#5599FF'],
                    series: [
                        {
                            name: '净值',
                            type: 'line',
                            animation: false,
                            symbol: 'none',
                            lineStyle: {
                                normal: {
                                    color: 'red',
                                    width: 3,
                                    shadowColor: 'rgba(0,0,0,0.4)',
                                    shadowBlur: 10,
                                    shadowOffsetY: 10
                                }
                            },
                            data: this.eval.netValueArrayRed
                        },
                        {
                            name: '净值',
                            type: 'line',
                            animation: false,
                            symbol: 'none',
                            lineStyle: {
                                normal: {
                                    color: '#53FF53',
                                    width: 3,
                                    shadowColor: 'rgba(0,0,0,0.4)',
                                    shadowBlur: 10,
                                    shadowOffsetY: 10
                                }
                            },
                            data: this.eval.netValueArrayGree
                        },
                        {
                            name: '历史回撤',
                            type: 'line',
                            animation: false,
                            xAxisIndex: 1,
                            yAxisIndex: 1,
                            symbol: 'none',
                            connectNulls: true,
                            itemStyle: {
                                normal: {
                                    color: function (o) {
                                        return '#5599FF';
                                    }
                                }
                            },
                            areaStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(
                                        0, 0, 0, 1,
                                        [
                                            { offset: 0, color: '#5599FF' },
                                            { offset: 1, color: '#FF5B4A' }
                                        ]
                                    )
                                }
                            },
                            lineStyle: {
                                width: 1
                            },
                            data: this.eval.hisLossArray
                        }
                    ]
                };
                var option3 = {
                    // title: {
                    //     text: '日净值波动',
                    //     left : 20
                    // },
                    graphic: graphic,
                    animation: false,
                    tooltip: {
                        trigger: 'axis',
                        formatter: function (params) {
                            var res = params[0].name + "<br/>";
                            res += "日净值波动:" + params[0].value + "%<br/>";
                            return res;
                        },
                    },
                    grid: {
                        left: 40,
                        right: 40,
                        bottom: 30,
                        containLabel: false
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: this.eval.dateArray
                    },
                    yAxis: {
                        axisLabel: {
                            formatter: '{value} %'
                        },
                        position: 'right'
                    },
                    series: [{
                        data: this.eval.netDailyProfitArray,
                        itemStyle: {
                            normal: {
                                shadowBlur: 10,
                                shadowColor: 'rgba(120, 36, 50, 0.5)',
                                shadowOffsetY: 5,
                                color: new echarts.graphic.RadialGradient(0.4, 0.3, 1, [{
                                    offset: 0,
                                    color: 'rgb(251, 118, 123)'
                                }, {
                                    offset: 1,
                                    color: 'rgb(204, 46, 72)'
                                }])
                            }
                        },
                        symbolSize: function (data) {
                            var a = Math.abs(data);
                            var size = 10;
                            size = size + a / 30 * 5;
                            if (size > 50)
                                size = 50;
                            return size;
                        },
                        type: 'scatter'
                    }]
                };
                var option4 = {
                    graphic: graphic,
                    animation: false,
                    title: {
                        text: '累计盈亏与手续费',
                        textStyle: {
                            fontWeight: 'normal'
                        },
                        left: 'left'
                    },
                    tooltip: {
                        // formatter : formatterTip,
                        trigger: 'axis'
                    },
                    grid: {
                        left: 40,
                        right: 40,
                        bottom: 30,
                        containLabel: false
                    },
                    legend: {
                        data: ['累计盈亏', '累计手续费'],
                        right: 40
                    },
                    toolbox: {
                        feature: {
                        }
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: this.eval.dateArray
                    },
                    yAxis: {
                        name: '单位：元',
                        type: 'value',
                        position: 'right'
                    },
                    color: ['red', '#5599FF'],
                    series: [
                        {
                            name: '累计盈亏',
                            type: 'line',
                            symbol: 'none',
                            lineStyle: {
                                normal: {
                                    width: 3,
                                    shadowColor: 'rgba(0,0,0,0.4)',
                                    shadowBlur: 10,
                                    shadowOffsetY: 10
                                }
                            },
                            itemStyle: {
                                normal: {
                                    color: 'red'
                                }
                            },
                            data: this.eval.sumProfitArray
                        },
                        {
                            name: '累计手续费',
                            type: 'line',
                            smooth: true,
                            symbol: 'none',
                            sampling: 'average',
                            itemStyle: {
                                normal: {
                                    color: '#428bed'
                                }
                            },
                            lineStyle: {
                                width: 1
                            },
                            areaStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                        offset: 0,
                                        color: '#428bed'
                                    }, {
                                        offset: 1,
                                        color: '#81e0fb'
                                    }])
                                }
                            },
                            data: this.eval.sumCommissionArray
                        }
                    ]
                };
                var option5 = {
                    graphic: graphic,
                    // title: {
                    //     text: '品种偏好',
                    //     left : 20
                    // },
                    animation: false,
                    grid: {
                        left: 40,
                        right: 40,
                        bottom: 10,
                        containLabel: false
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b}: {c} ({d}%)"
                    },
                    series: [
                        {
                            name: '品种偏好-手数',
                            type: 'pie',
                            selectedMode: 'single',
                            radius: [0, '20%'],
                            center: $(window).width() > 500 ? ['75%', 140] : ['50%', '30%'],

                            label: {
                                normal: {
                                    position: 'inner'
                                }
                            },
                            labelLine: {
                                normal: {
                                    show: false
                                }
                            },
                            data: this.res.inerHandArray
                        },
                        {
                            name: '品种偏好-手数',
                            type: 'pie',
                            radius: ['30%', '40%'],
                            center: $(window).width() > 500 ? ['75%', 140] : ['50%', '30%'],
                            label: {
                                formatter: '{b}: ({d}%)'
                            },
                            data: this.res.outerHandArray
                        },
                        {
                            name: '品种偏好-金额',
                            type: 'pie',
                            selectedMode: 'single',
                            radius: [0, '20%'],
                            center: $(window).width() > 500 ? ['25%', 140] : ['50%', '76%'],
                            label: {
                                normal: {
                                    position: 'inner'
                                }
                            },
                            labelLine: {
                                normal: {
                                    show: false
                                }
                            },
                            data: this.res.inerMoneyArray
                        },
                        {
                            name: '品种偏好-金额',
                            type: 'pie',
                            radius: ['30%', '40%'],
                            center: $(window).width() > 500 ? ['25%', 140] : ['50%', '76%'],
                            label: {
                                formatter: '{b}: ({d}%)'
                            },
                            data: this.res.outerMoneyArray
                        }
                    ]
                };
                var option6 = {
                    graphic: graphic,
                    animation: false,
                    title: {
                        text: ''
                    },
                    tooltip: {
                        // formatter : formatterTip,
                        trigger: 'axis'
                    },
                    grid: {
                        left: 40,
                        right: 40,
                        bottom: 40,
                        containLabel: false
                    },
                    xAxis: [
                        {
                            type: 'category',
                            boundaryGap: true,
                            axisTick: { onGap: false },
                            splitLine: { show: false },
                            axisLabel: {
                                interval: 0
                            },
                            data: this.res.tradeListX
                        }
                    ],
                    yAxis: [
                        {
                            name: '单位：元',
                            type: 'value',
                            scale: false,
                            boundaryGap: [0.05, 0.05],
                            splitArea: { show: true },
                            position: 'right'
                        }
                    ],
                    series: [
                        {
                            name: '品种逐笔盈亏',
                            type: 'bar',
                            barMaxWidth: 50,
                            yAxisIndex: 0,
                            data: this.res.tradeListY,
                            itemStyle: {
                                normal: {
                                    color: function (o) {
                                        if (o.value >= 0) {
                                            return new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                offset: 0,
                                                color: '#FF0033'
                                            }, {
                                                offset: 1,
                                                color: '#FF6666'
                                            }]);
                                        } else {
                                            return new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                offset: 0,
                                                color: '#66CC99'
                                            }, {
                                                offset: 1,
                                                color: '#339933'
                                            }]);
                                        }

                                    }
                                }
                            }
                        }
                    ]
                };
                var option7 = {
                    graphic: graphic,
                    animation: false,
                    title: {
                        text: ''
                    },
                    tooltip: {
                        // formatter : formatterTip,
                        trigger: 'axis'
                    },
                    grid: {
                        left: 40,
                        right: 40,
                        bottom: 40,
                        containLabel: false
                    },
                    toolbox: {
                        feature: {
                            saveAsImage: {
                                show: $(window).width() > 500
                            }
                        }
                    },
                    xAxis: [
                        {
                            type: 'category',
                            boundaryGap: true,
                            axisTick: { onGap: false },
                            splitLine: { show: false },
                            axisLabel: {
                                interval: 0
                            },
                            data: this.res.dateListX
                        }
                    ],
                    yAxis: [
                        {
                            name: '单位：元',
                            type: 'value',
                            scale: false,
                            boundaryGap: [0.05, 0.05],
                            splitArea: { show: true },
                            position: 'right'
                        }
                    ],
                    series: [
                        {
                            name: '品种逐笔盈亏',
                            type: 'bar',
                            barMaxWidth: 50,
                            yAxisIndex: 0,
                            data: this.res.dateListY,
                            itemStyle: {
                                normal: {
                                    color: function (o) {
                                        if (o.value >= 0) {
                                            return new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                offset: 0,
                                                color: '#FF0033'
                                            }, {
                                                offset: 1,
                                                color: '#FF6666'
                                            }]);
                                        } else {
                                            return new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                offset: 0,
                                                color: '#66CC99'
                                            }, {
                                                offset: 1,
                                                color: '#339933'
                                            }]);
                                        }

                                    }
                                }
                            }
                        }
                    ]
                };
                var option8 = {
                    graphic: graphic,
                    animation: false,
                    title: {
                        text: '当日盈亏与手续费',
                        textStyle: {
                            fontWeight: 'normal'
                        },
                        left: 'left'
                    },
                    tooltip: {
                        // formatter : formatterTip,
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    grid: {
                        left: 40,
                        right: 40,
                        bottom: 30,
                        containLabel: false
                    },
                    legend: {
                        data: ['当日盈亏', '当日手续费'],
                        right: 40
                    },
                    xAxis: {
                        type: 'category',
                        data: this.res.eval.dateArray
                    },
                    yAxis: {
                        name: '单位：元',
                        type: 'value',
                        position: 'right'
                    },
                    color: ['red', '#5599FF'],
                    series: [
                        {
                            name: '当日盈亏',
                            type: 'bar',
                            barGap: 0,
                            itemStyle: {
                                normal: {
                                    color: function (o) {
                                        if (o.value >= 0) {
                                            return new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                offset: 0,
                                                color: '#FF0033'
                                            }, {
                                                offset: 1,
                                                color: '#FF6666'
                                            }]);
                                        } else {
                                            return new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                offset: 0,
                                                color: '#66CC99'
                                            }, {
                                                offset: 1,
                                                color: '#339933'
                                            }]);
                                        }

                                    }
                                }
                            },
                            data: this.eval.dailyProfitArray
                        },
                        {
                            name: '当日手续费',
                            type: 'bar',
                            itemStyle: {
                                normal: {
                                    color: '#428bed'
                                }
                            },
                            data: this.eval.commissionArray
                        }
                    ]
                };
                var option9 = {
                    graphic: graphic,
                    animation: false,
                    title: {
                        text: ''
                    },
                    grid: {
                        left: 40,
                        right: 40,
                        bottom: 30,
                        top: 10,
                        containLabel: false
                    },
                    tooltip: {
                        // formatter : formatterTip,
                        trigger: 'axis'
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: true,
                        data: this.res.plateTradeListX
                    },
                    yAxis: {
                        name: '单位：元',
                        type: 'value',
                        scale: false,
                        boundaryGap: [0.05, 0.05],
                        splitArea: { show: true },
                        position: 'right'
                    },
                    series: [
                        {
                            name: '板块逐笔盈亏',
                            type: 'bar',
                            barMaxWidth: 50,
                            yAxisIndex: 0,
                            data: this.res.plateTradeListY,
                            itemStyle: {
                                normal: {
                                    color: function (o) {
                                        if (o.value >= 0) {
                                            return new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                offset: 0,
                                                color: '#FF0033'
                                            }, {
                                                offset: 1,
                                                color: '#FF6666'
                                            }]);
                                        } else {
                                            return new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                offset: 0,
                                                color: '#66CC99'
                                            }, {
                                                offset: 1,
                                                color: '#339933'
                                            }]);
                                        }

                                    }
                                }
                            }
                        }
                    ]
                };
                var option10 = {
                    graphic: graphic,
                    animation: false,
                    title: {
                        text: ''
                    },
                    grid: {
                        left: 40,
                        right: 40,
                        bottom: 30,
                        containLabel: false
                    },
                    tooltip: {
                        // formatter : formatterTip,
                        trigger: 'axis'
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: true,
                        data: this.res.plateDateListX
                    },
                    yAxis: {
                        name: '单位：元',
                        type: 'value',
                        scale: false,
                        boundaryGap: [0.05, 0.05],
                        splitArea: { show: true },
                        position: 'right'
                    },
                    series: [
                        {
                            name: '板块逐日盈亏',
                            type: 'bar',
                            barMaxWidth: 50,
                            yAxisIndex: 0,
                            data: this.res.plateDateListY,
                            itemStyle: {
                                normal: {
                                    color: function (o) {
                                        if (o.value >= 0) {
                                            return new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                offset: 0,
                                                color: '#FF0033'
                                            }, {
                                                offset: 1,
                                                color: '#FF6666'
                                            }]);
                                        } else {
                                            return new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                offset: 0,
                                                color: '#66CC99'
                                            }, {
                                                offset: 1,
                                                color: '#339933'
                                            }]);
                                        }

                                    }
                                }
                            }
                        }
                    ]
                };
                var option12 = {
                    graphic: graphic,
                    animation: false,
                    // title: {
                    //     text: '成交盈亏占比',
                    //     left:'left'
                    // },
                    tooltip: {
                        trigger: 'axis',
                        // formatter: function (params) {
                        //     var res = params[0].name + "<br/>";
                        //     res += params[0].seriesName + ":" + params[0].value + "%<br/>";
                        //     res += params[1].seriesName + ":" + params[1].value + "%<br/>";
                        //     return res;
                        // },
                    },
                    grid: {
                        left: 40,
                        right: 40,
                        bottom: 30,
                        containLabel: false
                    },
                    legend: {
                        data: ['成交额占比', '盈亏占比'],
                        right: 20
                    },
                    xAxis: {
                        type: 'category',
                        data: this.pro.bargainProductArray
                    },
                    yAxis: [
                        {
                            type: 'value',
                            scale: true,
                            axisLabel: {
                                formatter: '{value} %'
                            },
                            position: 'right'
                        }
                    ],
                    color: ['red', '#5599FF'],
                    series: [
                        {
                            name: '成交额占比',
                            type: 'bar',
                            barGap: 0,
                            barMaxWidth: 50,
                            itemStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                        offset: 0,
                                        color: '#428bed'
                                    }, {
                                        offset: 1,
                                        color: '#81e0fb'
                                    }])
                                }
                            },
                            data: this.pro.bargainLimitArray
                        },
                        {
                            name: '盈亏占比',
                            type: 'bar',
                            barMaxWidth: 50,
                            itemStyle: {
                                normal: {
                                    color: '#428bed'
                                }
                            },
                            itemStyle: {
                                normal: {
                                    color: function (o) {
                                        if (o.value >= 0) {
                                            return new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                offset: 0,
                                                color: '#FF0033'
                                            }, {
                                                offset: 1,
                                                color: '#FF6666'
                                            }]);
                                        } else {
                                            return new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                offset: 0,
                                                color: '#66CC99'
                                            }, {
                                                offset: 1,
                                                color: '#339933'
                                            }]);
                                        }

                                    }
                                }
                            },
                            data: [

                                { value: '100.0', label: { normal: { show: true, position: 'top' } } }

                            ]
                        }
                    ]
                };

                //    var option11 = {
                //         graphic: graphic,
                //         backgroundColor: '#fff',
                //         animation: false,
                //         legend: {
                //             right:40,
                //             data: ['MA5', 'MA10', 'MA20']
                //         },
                //         color:['#f8b80c','#eb1212','#1490de'],
                //         tooltip: {
                //             trigger: 'axis',
                //             axisPointer: {
                //                 type: 'cross'
                //             },
                //             backgroundColor: 'rgba(245, 245, 245, 0.8)',
                //             borderWidth: 1,
                //             borderColor: '#ccc',
                //             padding: 10,
                //             textStyle: {
                //                 color: '#000'
                //             },
                //             position: function (pos, params, el, elRect, size) {
                //                 var obj = {top: 10};
                //                 obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 30;
                //                 return obj;
                //             },
                //             formatter: function (param) {
                //                 if(param[0].seriesName == '持仓'){
                //                     var data = param[1];
                //                     return [
                //                         '日期: ' + data.name + '<hr size=1 style="margin: 3px 0">',
                //                         '开盘价: ' + data.data[0] + '<br/>',
                //                         '收盘价: ' + data.data[1] + '<br/>',
                //                         '最低价: ' + data.data[2] + '<br/>',
                //                         '最高价: ' + data.data[3] + '<br/>',
                //                         'MA5: ' + param[1].value + '<br/>',
                //                         'MA10: ' + param[2].value + '<br/>',
                //                         'MA20: ' + param[3].value + '<br/>',
                //                         '持仓: ' + (param.length==4?'-':param[0].value) + '%<br/>'
                //                     ].join('');
                //                 }else{
                //                     var data = param[0];
                //                     return [
                //                         '日期: ' + data.name + '<hr size=1 style="margin: 3px 0">',
                //                         '开盘价: ' + data.data[0] + '<br/>',
                //                         '收盘价: ' + data.data[1] + '<br/>',
                //                         '最低价: ' + data.data[2] + '<br/>',
                //                         '最高价: ' + data.data[3] + '<br/>',
                //                         'MA5: ' + param[1].value + '<br/>',
                //                         'MA10: ' + param[2].value + '<br/>',
                //                         'MA20: ' + param[3].value + '<br/>',
                //                         '持仓: ' + (param.length==4?'-':param[4].value) + '%<br/>'
                //                     ].join('');
                //                 }
                //             }
                //             // extraCssText: 'width: 170px'
                //         },
                //         axisPointer: {
                //             link: {xAxisIndex: 'all'},
                //             label: {
                //                 backgroundColor: '#777'
                //             }
                //         },
                //         grid: [
                //             {
                //                 left: 40,
                //                 right: 40,
                //                 bottom: '35%',
                //                 height: '50%',
                //             },
                //             {
                //                 left: 40,
                //                 right: 40,
                //                 bottom: '6%',
                //                 height: '20%',
                //             }
                //         ],
                //         xAxis: [
                //             {
                //                 type: 'category',
                //                 data: userNetData.categoryData,
                //                 scale: false,
                //                 boundaryGap : true,
                //                 axisLine: {onZero: false},
                //                 splitLine: {show: false},
                //                 axisLabel: {show: false},
                //                 splitNumber: 20,
                //                 min: 'dataMin',
                //                 max: 'dataMax',
                //                 axisPointer: {
                //                     z: 100
                //                 }
                //             },
                //             {
                //                 type: 'category',
                //                 gridIndex: 1,
                //                 data: userNetData.categoryData,
                //                 scale: true,
                //                 boundaryGap : true,
                //                 axisLine: {onZero: false},
                //                 axisTick: {show: false},
                //                 splitLine: {show: false},
                //                 axisLabel: {show: true},
                //                 splitNumber: 20
                //             }
                //         ],
                //         yAxis: [
                //             {
                //                 scale: true,
                //                 splitArea: {
                //                     show: false
                //                 },
                //                 position:'right'
                //             },
                //             {
                //                 scale: true,
                //                 gridIndex: 1,
                //                 splitNumber: 2,
                //                 axisLabel: {show: true},
                //                 axisLine: {show: true},
                //                 axisTick: {show: false},
                //                 splitLine: {show: true},
                //                 axisLabel: {
                //                     formatter: '{value} %'
                //                 },
                //                 position:'right'
                //             }
                //         ],
                //         series: [
                //             {
                //                 name: '净值',
                //                 type: 'candlestick',
                //                 barMaxWidth : '10px',
                //                 data: userNetData.values,
                //                 itemStyle: {
                //                     normal: {
                //                         color: upColor,
                //                         color0: downColor,
                //                         borderColor: upBorderColor,
                //                         borderColor0: null
                //                     }
                //                 },
                //             },
                //             {
                //                 name: 'MA5',
                //                 type: 'line',
                //                 data: this.calculateMA(5, userNetData),
                //                 smooth: true,
                //                 symbol: 'none',
                //                 lineStyle: {
                //                     normal: {opacity: 0.5}
                //                 }
                //             },
                //             {
                //                 name: 'MA10',
                //                 type: 'line',
                //                 data: this.calculateMA(10, userNetData),
                //                 smooth: true,
                //                 symbol: 'none',
                //                 lineStyle: {
                //                     normal: {opacity: 0.5}
                //                 }
                //             },
                //             {
                //                 name: 'MA20',
                //                 type: 'line',
                //                 data: this.calculateMA(20, userNetData),
                //                 smooth: true,
                //                 symbol: 'none',
                //                 lineStyle: {
                //                     normal: {opacity: 0.5}
                //                 }
                //             },
                //             {
                //                 name: '持仓',
                //                 color : '#5599FF',
                //                 type: 'bar',
                //                 xAxisIndex: 1,
                //                 yAxisIndex: 1,
                //                 data: this.eval.positionArray
                //             }
                //         ]
                //     }

               
                var arr1 = []
                 for(var key in this.proChoose.positionData){
                    //  console.log(key)
                     var obj1 = {}
                     obj1.name = key
                     obj1.type = 'line'
                     obj1.symbol = 'none'
                     obj1.data = this.proChoose.positionData[key]
                     arr1.push(obj1)
                 }
                //  console.log(arr1)
                var option13_1 = {
                    graphic: graphic,
                    // title: {
                    //     text: '品种持仓权益',
                    //     left:'left'
                    // },
                    animation: false,
                    tooltip: {
                        // formatter : formatterThouTip,
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        }
                    },
                    grid: {
                        left: 40,
                        right: 40,
                        bottom: 30,
                        containLabel: false
                    },
                    legend: {
                        data: this.proChoose.legendArray,
                        right: 40
                    },
                    xAxis: [
                        {
                            type: 'category',
                            axisPointer: {
                                type: 'shadow'
                            },
                            data: this.proChoose.dateArray
                        }
                    ],
                    yAxis: [
                        {
                            name: '单位：万元',
                            scale: true,
                            position: 'right'
                        },
                    ],
                    series: arr1
                };

               
                var arr2 = []
                 for(var key in this.proChoose.positionPlateData){
                    var obj2 = {}
                     obj2.name = key
                     obj2.type = 'line'
                     obj2.symbol = 'none'
                     obj2.data = this.proChoose.positionPlateData[key]
                     arr2.push(obj2)
                 }
                

                var option14_1 = {
                    graphic: graphic,
                    animation: false,
                    // title: {
                    //     text: '板块持仓权益',
                    //     left:'left'
                    // },
                    tooltip: {
                        // formatter : formatterThouTip,
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        }
                    },
                    grid: {
                        left: 40,
                        right: 40,
                        bottom: 30,
                        containLabel: false
                    },
                    toolbox: {
                        feature: {
                            saveAsImage: { show: $(window).width() > 500 }
                        }
                    },
                    legend: {
                        data: this.proChoose.legendPlateArray,
                        right: 40
                    },
                    xAxis: [
                        {
                            type: 'category',
                            axisPointer: {
                                type: 'shadow'
                            },
                            data: this.proChoose.dateArray
                        }
                    ],
                    yAxis: [
                        {
                            name: '单位：万元',
                            scale: true,
                            position: 'right'
                        },
                    ],
                    series:arr2
                };
                   var option15_1 = {
                        graphic: graphic,
                        // title: [{
                        //     text: '持仓K线',
                        //     left:'left'
                        // }],
                        backgroundColor: '#fff',
                        animation: false,

                        legend: {
                            right:40,
                            data: ['MA5', 'MA10', 'MA20']
                        },
                        color:['#f8b80c','#eb1212','#1490de'],
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'cross'
                            },
                            backgroundColor: 'rgba(245, 245, 245, 0.8)',
                            borderWidth: 1,
                            borderColor: '#ccc',
                            padding: 10,
                            textStyle: {
                                color: '#000'
                            },
                            // formatter: function (param) {
                            //     var data = param[0];
                            //     return [
                            //         '日期: ' + data.name + '<hr size=1 style="margin: 3px 0">',
                            //         '开盘价: ' + numberFormat(data.data[1],1) + '<br/>',
                            //         '收盘价: ' + numberFormat(data.data[2],1) + '<br/>',
                            //         '最低价: ' + numberFormat(data.data[3],1) + '<br/>',
                            //         '最高价: ' + numberFormat(data.data[4],1) + '<br/>',
                            //         'MA5: ' + numberFormat(param[1].value,1) + '<br/>',
                            //         'MA10: ' + numberFormat(param[2].value,1) + '<br/>',
                            //         'MA20: ' + numberFormat(param[3].value,1) + '<br/>',

                            //     ].join('');
                            // }
                            // extraCssText: 'width: 170px'
                        },
                        axisPointer: {
                            link: {xAxisIndex: 'all'},
                            label: {
                                backgroundColor: '#777'
                            }
                        },
                        grid: [
                            {
                                left: 40,
                                right: 40,
                                bottom: 30,
                                containLabel: false
                            }
                        ],
                        xAxis: [
                            {
                                type: 'category',
                                data: userNetData15.categoryData,
                                scale: true,
                                boundaryGap : true,
                                axisLine: {onZero: false},
                                splitLine: {show: false},
                                splitNumber: 20,
                                min: 'dataMin',
                                max: 'dataMax',
                                axisPointer: {
                                    z: 100
                                }
                            }
                        ],
                        yAxis: [
                            {
                                name: '单位：万元',
                                scale: true,
                                splitArea: {
                                    show: false
                                },
                                position:'right'
                            }
                        ],
                        series: [
                            {
                                name: '净值',
                                type: 'candlestick',
                                barMaxWidth : '10px',
                                data: userNetData15.values,
                                itemStyle: {
                                    normal: {
                                        color: upColor,
                                        color0: downColor,
                                        borderColor: upBorderColor,
                                        borderColor0: null
                                    }
                                },
                            },
                            {
                                name: 'MA5',
                                type: 'line',
                                data: this.calculateMA(5, userNetData15),
                                smooth: true,
                                symbol: 'none',
                                lineStyle: {
                                    normal: {opacity: 0.5}
                                }
                            },
                            {
                                name: 'MA10',
                                type: 'line',
                                data: this.calculateMA(10, userNetData15),
                                smooth: true,
                                symbol: 'none',
                                lineStyle: {
                                    normal: {opacity: 0.5}
                                }
                            },
                            {
                                name: 'MA20',
                                type: 'line',
                                data: this.calculateMA(20, userNetData15),
                                smooth: true,
                                symbol: 'none',
                                lineStyle: {
                                    normal: {opacity: 0.5}
                                }
                            }
                        ]
                    }

                var option16_1 = {
                    graphic: graphic,
                    // title: {
                    //     text: '多空盈亏分析',
                    //     textStyle: {
                    //         fontWeight : 'normal'
                    //     },
                    //     left:'left'
                    // },
                    animation: false,
                    grid: {
                        left: 40,
                        right: 40,
                        bottom: 30,
                        containLabel: false
                    },
                    tooltip: {
                        trigger: 'item',
                        // formatter : function (p) {
                        //     var value = p.value;
                        //     if(p.seriesName == "盈亏金额"){
                        //         value = numberFormat(value,0);
                        //     }
                        //     return p.seriesName+"<br/>" + p.name +"："+ value + "（"+p.percent+"%）";
                        // }
                    },
                    series: [
                        {
                            name: '盈亏手数',
                            type: 'pie',
                            selectedMode: 'single',
                            radius: [0, '20%'],
                            center: $(window).width() > 500 ? ['50%', '30%'] : ['50%', '30%'],
                            label: {
                                formatter: '{b}: ({d}%)'
                            },
                            data: [{ "name": "做多盈利手数", "value": "0" }, { "name": "做多亏损手数", "value": "0" }, { "name": "做空盈利手数", "value": "5" }, { "name": "做空亏损手数", "value": "0" }],
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                },
                                normal: {
                                    color: function (params) {
                                        //自定义颜色
                                        var colorList = [
                                            'red', '#1DCA7E', '#ff9f4a', '#569bff',
                                        ];
                                        return colorList[params.dataIndex]
                                    }
                                }
                            }
                        },
                        {
                            name: '盈亏金额',
                            type: 'pie',
                            radius: [0, '20%'],
                            center: $(window).width() > 500 ? ['50%', '75%'] : ['50%', '76%'],
                            label: {
                                formatter: '{b}: ({d}%)'
                            },
                            data: this.pro.onterMoneyArray,
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                },
                                normal: {
                                    color: function (params) {
                                        //自定义颜色
                                        var colorList = [
                                            'red', '#1DCA7E', '#ff9f4a', '#569bff',
                                        ];
                                        return colorList[params.dataIndex]
                                    }
                                }
                            }
                        }
                    ]
                };
                var option17_1 = {
                    graphic: graphic,
                    // title: {
                    //     text: '多空持仓保证金',
                    //     left:'left'
                    // },
                    animation: false,
                    tooltip: {
                        trigger: 'axis',
                        // formatter : formatterThouTip,
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        }
                    },
                    grid: {
                        left: 40,
                        right: 40,
                        bottom: 30,
                        containLabel: false
                    },
                    toolbox: {
                        feature: {
                            saveAsImage: { show: $(window).width() > 500 }
                        }
                    },
                    legend: {
                        data: ['多仓持仓', '空仓持仓', '拟合'],
                        right: 40
                    },
                    xAxis: [
                        {
                            type: 'category',
                            axisPointer: {
                                type: 'shadow'
                            },
                            data: this.proChoose.dateArray
                        }
                    ],
                    yAxis: [
                        {
                            name: '单位：万元',
                            scale: true,
                            position: 'right'
                        },
                    ],
                    series: [
                        {
                            name: '多仓持仓',
                            type: 'line',
                            symbol: 'none',
                            data: this.proChoose.longPositionArray
                        },
                        {
                            name: '空仓持仓',
                            type: 'line',
                            symbol: 'none',
                            data: this.proChoose.shortPositionArray
                        },
                        {
                            name: '拟合',
                            type: 'line',
                            symbol: 'none',
                            data: this.proChoose.matchPositionArray
                        }
                    ]
                };
                var option18_1 = {
                    graphic: graphic,
                    // title: {
                    //     text: '逐月盈亏',
                    //     textStyle: {
                    //         fontWeight : 'normal'
                    //     },
                    //     left:'left'
                    // },
                    animation: false,
                    tooltip: {
                        trigger: 'axis',
                        // formatter : formatterTip,
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    toolbox: {
                        feature: {
                            saveAsImage: { show: $(window).width() > 500 }
                        }
                    },
                    grid: {
                        left: 40,
                        right: 40,
                        bottom: 30,
                        containLabel: false
                    },
                    // legend: {
                    //     data:['盈亏','手续费'],
                    //     right:20
                    // },
                    xAxis: {
                        type: 'category',
                        data: this.eval.monthProfitDateArray
                    },
                    yAxis: [
                        {
                            boundaryGap: ['5%', '5%'],
                            name: '单位：元',
                            type: 'value',
                            position: 'right'
                        }
                    ],
                    // color:['red','#5599FF'],
                    series: [
                        {
                            name: '盈亏',
                            type: 'bar',
                            barMaxWidth: 50,
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                            barGap: 0,
                            itemStyle: {
                                normal: {
                                    color: function (o) {
                                        if (o.value >= 0) {
                                            return new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                offset: 0,
                                                color: '#FF0033'
                                            }, {
                                                offset: 1,
                                                color: '#FF6666'
                                            }]);
                                        } else {
                                            return new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                offset: 0,
                                                color: '#66CC99'
                                            }, {
                                                offset: 1,
                                                color: '#339933'
                                            }]);
                                        }

                                    }
                                }
                            },
                            data: this.eval.monthProfitArray
                        }
                    ]
                };
                var option19_1 = {
                    graphic: graphic,
                    // title: {
                    //     text: '板块逐月盈亏',
                    //     textStyle: {
                    //         fontWeight : 'normal'
                    //     },
                    //     left:'left'
                    // },
                    animation: false,
                    tooltip: {
                        trigger: 'axis',
                        // formatter : formatterTip,
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    grid: {
                        left: 40,
                        right: 40,
                        bottom: 30,
                        containLabel: false
                    },
                    legend: {
                        data: this.res.monthEval.plateArray,
                        right: 20
                    },
                    xAxis: {
                        type: 'category',
                        data: this.eval.monthProfitDateArray
                    },
                    yAxis: [
                        {
                            boundaryGap: ['5%', '5%'],
                            name: '单位：元',
                            type: 'value',
                            position: 'right'
                        }
                    ],
                    // color:['red','#5599FF'],
                    series: [

                        {
                            name: '贵金属',
                            type: 'bar',
                            barMaxWidth: 50,
                            barGap: 0,
                            data: this.splitMonthData([{ "flag": true, "value": 22170 }])
                        },

                    ]
                };
                var option20_1 = {
                    graphic: graphic,
                    // title: {
                    //     text: '板块逐月成交保证金',
                    //     textStyle: {
                    //         fontWeight : 'normal'
                    //     },
                    //     left:'left'
                    // },
                    animation: false,
                    tooltip: {
                        trigger: 'axis',
                        // formatter : formatterThouTip,
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    grid: {
                        left: 40,
                        right: 40,
                        bottom: 30,
                        containLabel: false
                    },
                    legend: {
                        data: this.res.monthEval.plateArray,
                        right: 20
                    },
                    xAxis: {
                        type: 'category',
                        data: this.eval.monthProfitDateArray
                    },
                    yAxis: [
                        {
                            boundaryGap: ['0%', '10%'],
                            name: '单位：万元',
                            type: 'value',
                            position: 'right'
                        }
                    ],
                    color: ['#FE3737', '#3682D0', '#DEC30D', '#B2502E', '#80D8D5', '#483727', '#670A07', '#B370FF', '#F7B535', '#818181', '#40BDD0', '#8FCB25',],
                    series: [

                        {
                            name: '贵金属',
                            type: 'bar',
                            label: {
                                normal: {
                                    // formatter : formatterThou,
                                    show: true,
                                    position: 'top'
                                }
                            },
                            barMaxWidth: 50,
                            barGap: 0,
                            data: [105.5006]
                        },

                    ]
                };
                var option21_1 = {
                    graphic: graphic,
                    // title: {
                    //     text: '周期盈亏',
                    //     textStyle: {
                    //         fontWeight : 'normal'
                    //     },
                    //     left:'left'
                    // },
                    animation: false,
                    toolbox: {
                        feature: {
                            saveAsImage: { show: $(window).width() > 500 }
                        }
                    },
                    tooltip: {
                        trigger: 'item',
                        // formatter : function (p) {
                        //     var tip = "";
                        //     tip += getColor(p) + p.seriesName +"："+ numberFormat(p.value,0)+"<br/>";
                        //     return tip;
                        // },
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    grid: {
                        left: 40,
                        right: 40,
                        bottom: 30,
                        top: '10%',
                        containLabel: false
                    },
                    legend: {
                        data: ['日内盈利', '短线盈利', '中线盈利', '长线盈利', '日内亏损', '短线亏损', '中线亏损', '长线亏损'],
                        right: 20
                    },
                    xAxis: {
                        data: ['  ', '     '],
                        silent: false,
                        axisLine: { onZero: true },
                        splitLine: { show: false },
                        splitArea: { show: false }
                    },
                    yAxis: {
                        name: '单位：元',
                        splitArea: { show: false },
                        position: 'right'
                    },
                    // color:['red','#5599FF'],
                    series: [
                        {
                            name: '日内盈利',
                            type: 'bar',
                            barMaxWidth: 100,
                            label: {
                                normal: {
                                    // formatter : formatter,
                                    show: true,
                                    position: 'inside'
                                }
                            },
                            stack: 'one',
                            data: [300.0, '']
                        },
                        {
                            name: '短线盈利',
                            type: 'bar',
                            barMaxWidth: 100,
                            label: {
                                normal: {
                                    // formatter : formatter,
                                    show: true,
                                    position: 'inside'
                                }
                            },
                            stack: 'one',
                            data: [this.res.cycleEval.dailyGain, '']
                        },
                        {
                            name: '中线盈利',
                            type: 'bar',
                            barMaxWidth: 100,
                            label: {
                                normal: {
                                    // formatter : formatter,
                                    show: true,
                                    position: 'inside'
                                }
                            },
                            stack: 'one',
                            data: [this.res.cycleEval.shortGain, '']
                        },
                        {
                            name: '长线盈利',
                            type: 'bar',
                            barMaxWidth: 100,
                            label: {
                                normal: {
                                    // formatter : formatter,
                                    show: true,
                                    position: 'inside'
                                }
                            },
                            stack: 'one',
                            data: [this.res.cycleEval.centerGain, '']
                        },
                        {
                            name: '日内亏损',
                            type: 'bar',
                            barMaxWidth: 100,
                            label: {
                                normal: {
                                    // formatter : formatter,
                                    show: true,
                                    position: 'inside'
                                }
                            },
                            stack: 'two',
                            data: ['', this.res.cycleEval.dailyLoss]
                        },

                        {
                            name: '短线亏损',
                            type: 'bar',
                            barMaxWidth: 100,
                            label: {
                                normal: {
                                    // formatter : formatter,
                                    show: true,
                                    position: 'inside'
                                }
                            },
                            stack: 'two',
                            data: ['', this.res.cycleEval.shortLoss]
                        },

                        {
                            name: '中线亏损',
                            type: 'bar',
                            barMaxWidth: 100,
                            label: {
                                normal: {
                                    // formatter : formatter,
                                    show: true,
                                    position: 'inside'
                                }
                            },
                            stack: 'two',
                            data: ['', this.res.cycleEval.centerLoss]
                        },
                        {
                            name: '长线亏损',
                            type: 'bar',
                            barMaxWidth: 100,
                            label: {
                                normal: {
                                    // formatter : formatter,
                                    show: true,
                                    position: 'inside'
                                }
                            },
                            stack: 'two',
                            data: ['', this.res.cycleEval.longLoss]
                        },
                    ]
                };
                var option22_1 = {
                    graphic: graphic,
                    // title: {
                    //     text: '周期胜算率',
                    //     textStyle: {
                    //         fontWeight : 'normal'
                    //     },
                    //     left:'left'
                    // },
                    animation: false,
                    tooltip: {
                        trigger: 'axis',
                        // formatter : function(params){
                        //     var res = params[0].name+"<br/>";
                        //     res += params[0].seriesName+"："+ numberFormat(params[0].value,2)+"%<br/>";
                        //     return res;
                        // },
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    grid: {
                        left: 40,
                        right: 40,
                        bottom: 30,
                        containLabel: false
                    },
                    xAxis: {
                        type: 'category',
                        data: ['日内', '短线', '中线', '长线', '整体']
                    },
                    yAxis: [
                        {
                            boundaryGap: ['0%', '10%'],
                            type: 'value',
                            position: 'right'
                        }
                    ],
                    // color:['red','#5599FF'],
                    series: [
                        {
                            name: '胜算率',
                            type: 'bar',
                            barMaxWidth: 50,
                            label: {
                                normal: {
                                    show: true,
                                    // formatter : function(p){
                                    //     return numberFormat(p.value,2)+"%";
                                    // },
                                    position: 'top'
                                }
                            },
                            barGap: 0,
                            data: this.res.cycleEval.handRateArray
                        },
                    ]
                };
                if (this.settingArray[0] == 1) {
                    var myChart1 = echarts.init(document.getElementById('main1'));
                    myChart1.setOption(option1);  // 净值 持仓
                }
                // if(this.settingArray[0] == 1){
                //     var face = '0';
                //     if(face == '0'){
                //     var    myChart11 = echarts.init(document.getElementById('main11'));
                //         myChart11.setOption(option11); // 净值K线
                //     }
                // }
                if (this.settingArray[0] == 1) {
                    var myChart2 = echarts.init(document.getElementById('main2'));
                    myChart2.setOption(option2); //   净值 回撤
                }
                if (this.settingArray[0] == 1) {
                    var myChart3 = echarts.init(document.getElementById('main3'));
                    myChart3.setOption(option3); // 日净值波动
                }
                if (this.settingArray[0] == 1) {
                    var myChart4 = echarts.init(document.getElementById('main4'));
                    myChart4.setOption(option4); //  累计 盈亏与手续费
                    var myChart8 = echarts.init(document.getElementById('main8'));
                    myChart8.setOption(option8); //   当日 盈亏与手续费
                }
                if (this.settingArray[2] == 1) {
                    var myChart9 = echarts.init(document.getElementById('main9'));
                    myChart9.setOption(option9); //   板块逐笔盈亏
                    var myChart10 = echarts.init(document.getElementById('main10'));
                    myChart10.setOption(option10);  // 板块逐日盈亏
                }
                if (this.settingArray[2] == 1) {
                    var myChart7 = echarts.init(document.getElementById('main7'));
                    myChart7.setOption(option7); //  品种逐笔盈亏
                    var myChart6 = echarts.init(document.getElementById('main6'));
                    myChart6.setOption(option6); //  品种逐笔盈亏
                }
                if (this.settingArray[2] == 1) {
                    var myChart5 = echarts.init(document.getElementById('main5'));
                    myChart5.setOption(option5); // 品种偏好
                }
                if (this.settingArray[2] == 1) {
                    var myChart12 = echarts.init(document.getElementById('main12'));
                    myChart12.setOption(option12); // 成交盈亏占比
                }
                if (this.settingArray[2] == 1) {
                    var myChart13_1 = echarts.init(document.getElementById('main13_1'));
                    myChart13_1.setOption(option13_1); //
                }
                if (this.settingArray[2] == 1) {
                    var myChart14_1 = echarts.init(document.getElementById('main14_1'));
                    myChart14_1.setOption(option14_1); //
                }
                if(this.settingArray[2] == 1){
                 var   myChart15_1 = echarts.init(document.getElementById('main15_1'));
                    myChart15_1.setOption(option15_1); //
                }
                if (this.settingArray[1] == 1) {
                    var myChart16_1 = echarts.init(document.getElementById('main16_1'));
                    myChart16_1.setOption(option16_1); //
                }
                if (this.settingArray[2] == 1) {
                    var myChart17_1 = echarts.init(document.getElementById('main17_1'));
                    myChart17_1.setOption(option17_1); //
                }
                if (this.settingArray[0] == 1) {
                    var myChart18_1 = echarts.init(document.getElementById('main18_1'));
                    myChart18_1.setOption(option18_1); //
                }
                if (this.settingArray[2] == 1) {
                    var myChart19_1 = echarts.init(document.getElementById('main19_1'));
                    myChart19_1.setOption(option19_1); //
                }
                if (this.settingArray[2] == 1) {
                    var myChart20_1 = echarts.init(document.getElementById('main20_1'));
                    myChart20_1.setOption(option20_1); //
                }
                if (this.settingArray[3] == 1) {
                    var myChart21_1 = echarts.init(document.getElementById('main21_1'));
                    myChart21_1.setOption(option21_1); //
                }
                if (this.settingArray[3] == 1) {
                    var myChart22_1 = echarts.init(document.getElementById('main22_1'));
                    myChart22_1.setOption(option22_1); //
                }
                this.main1_base64 = this.drawcharts(option1,'main1');
                this.main2_base64 = this.drawcharts(option2,'main2');
                this.main3_base64 = this.drawcharts(option3,'main3');
                this.main4_base64 = this.drawcharts(option4,'main4');
                this.main5_base64 = this.drawcharts(option5,'main5');
                this.main6_base64 = this.drawcharts(option6,'main6');
                this.main7_base64 = this.drawcharts(option7,'main7');
                this.main8_base64 = this.drawcharts(option8,'main8');
                this.main9_base64 = this.drawcharts(option9,'main9');
                this.main10_base64 = this.drawcharts(option10,'main10');
                // this.main11_base64 = this.drawcharts(option11,'main11');
                this.main12_base64 = this.drawcharts(option12,'main12');
                this.main13_base64 = this.drawcharts(option13_1,'main13_1');
                this.main14_base64 = this.drawcharts(option14_1,'main14_1');
                this.main15_base64 = this.drawcharts(option15_1,'main15_1');
                this.main16_base64 = this.drawcharts(option16_1,'main16_1');
                this.main17_base64 = this.drawcharts(option17_1,'main17_1');
                this.main18_base64 = this.drawcharts(option18_1,'main18_1');
                this.main19_base64 = this.drawcharts(option19_1,'main19_1');
                this.main20_base64 = this.drawcharts(option20_1,'main20_1');
                this.main21_base64 = this.drawcharts(option21_1,'main21_1');
                this.main22_base64 = this.drawcharts(option22_1,'main22_1');
            },
        },
    };
</script>
<style scoped>

.panel{
    background-image: url('../../../assets/images/crm/watermarkNew.png') !important;
    background-size: 1381px 350px;
}
</style>


// WEBPACK FOOTER //
// src/view/crm/yunReport/index.vue